function pt (u) {
  if (u === void 0)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    )
  return u
}
function yi (u, t) {
  ;(u.prototype = Object.create(t.prototype)),
    (u.prototype.constructor = u),
    (u.__proto__ = t)
}
/*!
 * GSAP 3.11.0
 * https://greensock.com
 *
 * @license Copyright 2008-2022, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */
var Z = {
    autoSleep: 120,
    force3D: 'auto',
    nullTargetWarn: 1,
    units: {
      lineHeight: ''
    }
  },
  Vt = {
    duration: 0.5,
    overwrite: !1,
    delay: 0
  },
  Me,
  ut,
  N,
  it = 1e8,
  C = 1 / it,
  De = Math.PI * 2,
  Ar = De / 4,
  Rr = 0,
  xi = Math.sqrt,
  Er = Math.cos,
  Fr = Math.sin,
  X = function (t) {
    return typeof t == 'string'
  },
  z = function (t) {
    return typeof t == 'function'
  },
  mt = function (t) {
    return typeof t == 'number'
  },
  Ae = function (t) {
    return typeof t == 'undefined'
  },
  ft = function (t) {
    return typeof t == 'object'
  },
  Q = function (t) {
    return t !== !1
  },
  vi = function () {
    return typeof window != 'undefined'
  },
  pe = function (t) {
    return z(t) || X(t)
  },
  Ti =
    (typeof ArrayBuffer == 'function' && ArrayBuffer.isView) || function () {},
  G = Array.isArray,
  Re = /(?:-?\.?\d|\.)+/gi,
  wi = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
  Ut = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
  Ee = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
  bi = /[+-]=-?[.\d]+/,
  Pi = /[^,'"\[\]\s]+/gi,
  zr = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
  R,
  rt,
  Fe,
  ze,
  j = {},
  me = {},
  Si,
  Oi = function (t) {
    return (me = At(t, j)) && et
  },
  Le = function (t, e) {
    return console.warn(
      'Invalid property',
      t,
      'set to',
      e,
      'Missing plugin? gsap.registerPlugin()'
    )
  },
  ge = function (t, e) {
    return !e && console.warn(t)
  },
  ki = function (t, e) {
    return (t && (j[t] = e) && me && (me[t] = e)) || j
  },
  ee = function () {
    return 0
  },
  Lr = {
    suppressEvents: !0,
    isStart: !0
  },
  ie = {
    suppressEvents: !0
  },
  Ie = {},
  Tt = [],
  Be = {},
  Ci,
  J = {},
  Ne = {},
  Mi = 30,
  ye = [],
  Ve = '',
  Ue = function (t) {
    var e = t[0],
      i,
      r
    if ((ft(e) || z(e) || (t = [t]), !(i = (e._gsap || {}).harness))) {
      for (r = ye.length; r-- && !ye[r].targetTest(e); );
      i = ye[r]
    }
    for (r = t.length; r--; )
      (t[r] && (t[r]._gsap || (t[r]._gsap = new ir(t[r], i)))) || t.splice(r, 1)
    return t
  },
  Dt = function (t) {
    return t._gsap || Ue(at(t))[0]._gsap
  },
  Di = function (t, e, i) {
    return (i = t[e]) && z(i)
      ? t[e]()
      : (Ae(i) && t.getAttribute && t.getAttribute(e)) || i
  },
  H = function (t, e) {
    return (t = t.split(',')).forEach(e) || t
  },
  I = function (t) {
    return Math.round(t * 1e5) / 1e5 || 0
  },
  q = function (t) {
    return Math.round(t * 1e7) / 1e7 || 0
  },
  Yt = function (t, e) {
    var i = e.charAt(0),
      r = parseFloat(e.substr(2))
    return (
      (t = parseFloat(t)),
      i === '+' ? t + r : i === '-' ? t - r : i === '*' ? t * r : t / r
    )
  },
  Ir = function (t, e) {
    for (var i = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < i; );
    return r < i
  },
  xe = function () {
    var t = Tt.length,
      e = Tt.slice(0),
      i,
      r
    for (Be = {}, Tt.length = 0, i = 0; i < t; i++)
      (r = e[i]),
        r && r._lazy && (r.render(r._lazy[0], r._lazy[1], !0)._lazy = 0)
  },
  Ai = function (t, e, i, r) {
    Tt.length && xe(), t.render(e, i, r || ut), Tt.length && xe()
  },
  Ri = function (t) {
    var e = parseFloat(t)
    return (e || e === 0) && (t + '').match(Pi).length < 2
      ? e
      : X(t)
      ? t.trim()
      : t
  },
  Ei = function (t) {
    return t
  },
  nt = function (t, e) {
    for (var i in e) i in t || (t[i] = e[i])
    return t
  },
  Br = function (t) {
    return function (e, i) {
      for (var r in i)
        r in e || (r === 'duration' && t) || r === 'ease' || (e[r] = i[r])
    }
  },
  At = function (t, e) {
    for (var i in e) t[i] = e[i]
    return t
  },
  Fi = function u (t, e) {
    for (var i in e)
      i !== '__proto__' &&
        i !== 'constructor' &&
        i !== 'prototype' &&
        (t[i] = ft(e[i]) ? u(t[i] || (t[i] = {}), e[i]) : e[i])
    return t
  },
  ve = function (t, e) {
    var i = {},
      r
    for (r in t) r in e || (i[r] = t[r])
    return i
  },
  re = function (t) {
    var e = t.parent || R,
      i = t.keyframes ? Br(G(t.keyframes)) : nt
    if (Q(t.inherit)) for (; e; ) i(t, e.vars.defaults), (e = e.parent || e._dp)
    return t
  },
  Nr = function (t, e) {
    for (var i = t.length, r = i === e.length; r && i-- && t[i] === e[i]; );
    return i < 0
  },
  zi = function (t, e, i, r, n) {
    i === void 0 && (i = '_first'), r === void 0 && (r = '_last')
    var s = t[r],
      a
    if (n) for (a = e[n]; s && s[n] > a; ) s = s._prev
    return (
      s ? ((e._next = s._next), (s._next = e)) : ((e._next = t[i]), (t[i] = e)),
      e._next ? (e._next._prev = e) : (t[r] = e),
      (e._prev = s),
      (e.parent = e._dp = t),
      e
    )
  },
  Te = function (t, e, i, r) {
    i === void 0 && (i = '_first'), r === void 0 && (r = '_last')
    var n = e._prev,
      s = e._next
    n ? (n._next = s) : t[i] === e && (t[i] = s),
      s ? (s._prev = n) : t[r] === e && (t[r] = n),
      (e._next = e._prev = e.parent = null)
  },
  gt = function (t, e) {
    t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove(t),
      (t._act = 0)
  },
  Rt = function (t, e) {
    if (t && (!e || e._end > t._dur || e._start < 0))
      for (var i = t; i; ) (i._dirty = 1), (i = i.parent)
    return t
  },
  Vr = function (t) {
    for (var e = t.parent; e && e.parent; )
      (e._dirty = 1), e.totalDuration(), (e = e.parent)
    return t
  },
  Ye = function (t, e, i, r) {
    return (
      t._startAt &&
      (ut
        ? t._startAt.revert(ie)
        : (t.vars.immediateRender && !t.vars.autoRevert) ||
          t._startAt.render(e, !0, r))
    )
  },
  Ur = function u (t) {
    return !t || (t._ts && u(t.parent))
  },
  Li = function (t) {
    return t._repeat ? Xt(t._tTime, (t = t.duration() + t._rDelay)) * t : 0
  },
  Xt = function (t, e) {
    var i = Math.floor((t /= e))
    return t && i === t ? i - 1 : i
  },
  we = function (t, e) {
    return (
      (t - e._start) * e._ts +
      (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur)
    )
  },
  be = function (t) {
    return (t._end = q(
      t._start + (t._tDur / Math.abs(t._ts || t._rts || C) || 0)
    ))
  },
  Pe = function (t, e) {
    var i = t._dp
    return (
      i &&
        i.smoothChildTiming &&
        t._ts &&
        ((t._start = q(
          i._time -
            (t._ts > 0
              ? e / t._ts
              : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)
        )),
        be(t),
        i._dirty || Rt(i, t)),
      t
    )
  },
  Ii = function (t, e) {
    var i
    if (
      ((e._time || (e._initted && !e._dur)) &&
        ((i = we(t.rawTime(), e)),
        (!e._dur || se(0, e.totalDuration(), i) - e._tTime > C) &&
          e.render(i, !0)),
      Rt(t, e)._dp && t._initted && t._time >= t._dur && t._ts)
    ) {
      if (t._dur < t.duration())
        for (i = t; i._dp; )
          i.rawTime() >= 0 && i.totalTime(i._tTime), (i = i._dp)
      t._zTime = -C
    }
  },
  ht = function (t, e, i, r) {
    return (
      e.parent && gt(e),
      (e._start = q(
        (mt(i) ? i : i || t !== R ? st(t, i, e) : t._time) + e._delay
      )),
      (e._end = q(
        e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)
      )),
      zi(t, e, '_first', '_last', t._sort ? '_start' : 0),
      Xe(e) || (t._recent = e),
      r || Ii(t, e),
      t._ts < 0 && Pe(t, t._tTime),
      t
    )
  },
  Bi = function (t, e) {
    return (
      (j.ScrollTrigger || Le('scrollTrigger', e)) &&
      j.ScrollTrigger.create(e, t)
    )
  },
  Ni = function (t, e, i, r) {
    if ((je(t, e), !t._initted)) return 1
    if (
      !i &&
      t._pt &&
      ((t._dur && t.vars.lazy !== !1) || (!t._dur && t.vars.lazy)) &&
      Ci !== tt.frame
    )
      return Tt.push(t), (t._lazy = [e, r]), 1
  },
  Yr = function u (t) {
    var e = t.parent
    return e && e._ts && e._initted && !e._lock && (e.rawTime() < 0 || u(e))
  },
  Xe = function (t) {
    var e = t.data
    return e === 'isFromStart' || e === 'isStart'
  },
  Xr = function (t, e, i, r) {
    var n = t.ratio,
      s =
        e < 0 ||
        (!e &&
          ((!t._start && Yr(t) && !(!t._initted && Xe(t))) ||
            ((t._ts < 0 || t._dp._ts < 0) && !Xe(t))))
          ? 0
          : 1,
      a = t._rDelay,
      o = 0,
      f,
      h,
      c
    if (
      (a &&
        t._repeat &&
        ((o = se(0, t._tDur, e)),
        (h = Xt(o, a)),
        t._yoyo && h & 1 && (s = 1 - s),
        h !== Xt(t._tTime, a) &&
          ((n = 1 - s), t.vars.repeatRefresh && t._initted && t.invalidate())),
      s !== n || ut || r || t._zTime === C || (!e && t._zTime))
    ) {
      if (!t._initted && Ni(t, e, r, i)) return
      for (
        c = t._zTime,
          t._zTime = e || (i ? C : 0),
          i || (i = e && !c),
          t.ratio = s,
          t._from && (s = 1 - s),
          t._time = 0,
          t._tTime = o,
          f = t._pt;
        f;

      )
        f.r(s, f.d), (f = f._next)
      e < 0 && Ye(t, e, i, !0),
        t._onUpdate && !i && ot(t, 'onUpdate'),
        o && t._repeat && !i && t.parent && ot(t, 'onRepeat'),
        (e >= t._tDur || e < 0) &&
          t.ratio === s &&
          (s && gt(t, 1),
          i ||
            (ot(t, s ? 'onComplete' : 'onReverseComplete', !0),
            t._prom && t._prom()))
    } else t._zTime || (t._zTime = e)
  },
  qr = function (t, e, i) {
    var r
    if (i > e)
      for (r = t._first; r && r._start <= i; ) {
        if (r.data === 'isPause' && r._start > e) return r
        r = r._next
      }
    else
      for (r = t._last; r && r._start >= i; ) {
        if (r.data === 'isPause' && r._start < e) return r
        r = r._prev
      }
  },
  qt = function (t, e, i, r) {
    var n = t._repeat,
      s = q(e) || 0,
      a = t._tTime / t._tDur
    return (
      a && !r && (t._time *= s / t._dur),
      (t._dur = s),
      (t._tDur = n ? (n < 0 ? 1e10 : q(s * (n + 1) + t._rDelay * n)) : s),
      a > 0 && !r ? Pe(t, (t._tTime = t._tDur * a)) : t.parent && be(t),
      i || Rt(t.parent, t),
      t
    )
  },
  Vi = function (t) {
    return t instanceof $ ? Rt(t) : qt(t, t._dur)
  },
  Gr = {
    _start: 0,
    endTime: ee,
    totalDuration: ee
  },
  st = function u (t, e, i) {
    var r = t.labels,
      n = t._recent || Gr,
      s = t.duration() >= it ? n.endTime(!1) : t._dur,
      a,
      o,
      f
    return X(e) && (isNaN(e) || e in r)
      ? ((o = e.charAt(0)),
        (f = e.substr(-1) === '%'),
        (a = e.indexOf('=')),
        o === '<' || o === '>'
          ? (a >= 0 && (e = e.replace(/=/, '')),
            (o === '<' ? n._start : n.endTime(n._repeat >= 0)) +
              (parseFloat(e.substr(1)) || 0) *
                (f ? (a < 0 ? n : i).totalDuration() / 100 : 1))
          : a < 0
          ? (e in r || (r[e] = s), r[e])
          : ((o = parseFloat(e.charAt(a - 1) + e.substr(a + 1))),
            f && i && (o = (o / 100) * (G(i) ? i[0] : i).totalDuration()),
            a > 1 ? u(t, e.substr(0, a - 1), i) + o : s + o))
      : e == null
      ? s
      : +e
  },
  ne = function (t, e, i) {
    var r = mt(e[1]),
      n = (r ? 2 : 1) + (t < 2 ? 0 : 1),
      s = e[n],
      a,
      o
    if ((r && (s.duration = e[1]), (s.parent = i), t)) {
      for (a = s, o = i; o && !('immediateRender' in a); )
        (a = o.vars.defaults || {}), (o = Q(o.vars.inherit) && o.parent)
      ;(s.immediateRender = Q(a.immediateRender)),
        t < 2 ? (s.runBackwards = 1) : (s.startAt = e[n - 1])
    }
    return new V(e[0], s, e[n + 1])
  },
  wt = function (t, e) {
    return t || t === 0 ? e(t) : e
  },
  se = function (t, e, i) {
    return i < t ? t : i > e ? e : i
  },
  W = function (t, e) {
    return !X(t) || !(e = zr.exec(t)) ? '' : e[1]
  },
  Wr = function (t, e, i) {
    return wt(i, function (r) {
      return se(t, e, r)
    })
  },
  qe = [].slice,
  Ui = function (t, e) {
    return (
      t &&
      ft(t) &&
      'length' in t &&
      ((!e && !t.length) || (t.length - 1 in t && ft(t[0]))) &&
      !t.nodeType &&
      t !== rt
    )
  },
  $r = function (t, e, i) {
    return (
      i === void 0 && (i = []),
      t.forEach(function (r) {
        var n
        return (X(r) && !e) || Ui(r, 1)
          ? (n = i).push.apply(n, at(r))
          : i.push(r)
      }) || i
    )
  },
  at = function (t, e, i) {
    return N && !e && N.selector
      ? N.selector(t)
      : X(t) && !i && (Fe || !Wt())
      ? qe.call((e || ze).querySelectorAll(t), 0)
      : G(t)
      ? $r(t, i)
      : Ui(t)
      ? qe.call(t, 0)
      : t
      ? [t]
      : []
  },
  Ge = function (t) {
    return (
      (t = at(t)[0] || ge('Invalid scope') || {}),
      function (e) {
        var i = t.current || t.nativeElement || t
        return at(
          e,
          i.querySelectorAll
            ? i
            : i === t
            ? ge('Invalid scope') || ze.createElement('div')
            : t
        )
      }
    )
  },
  Yi = function (t) {
    return t.sort(function () {
      return 0.5 - Math.random()
    })
  },
  Xi = function (t) {
    if (z(t)) return t
    var e = ft(t)
        ? t
        : {
            each: t
          },
      i = Et(e.ease),
      r = e.from || 0,
      n = parseFloat(e.base) || 0,
      s = {},
      a = r > 0 && r < 1,
      o = isNaN(r) || a,
      f = e.axis,
      h = r,
      c = r
    return (
      X(r)
        ? (h = c =
            {
              center: 0.5,
              edges: 0.5,
              end: 1
            }[r] || 0)
        : !a && o && ((h = r[0]), (c = r[1])),
      function (l, d, p) {
        var _ = (p || e).length,
          m = s[_],
          g,
          x,
          v,
          T,
          y,
          S,
          P,
          b,
          w
        if (!m) {
          if (((w = e.grid === 'auto' ? 0 : (e.grid || [1, it])[1]), !w)) {
            for (
              P = -it;
              P < (P = p[w++].getBoundingClientRect().left) && w < _;

            );
            w--
          }
          for (
            m = s[_] = [],
              g = o ? Math.min(w, _) * h - 0.5 : r % w,
              x = w === it ? 0 : o ? (_ * c) / w - 0.5 : (r / w) | 0,
              P = 0,
              b = it,
              S = 0;
            S < _;
            S++
          )
            (v = (S % w) - g),
              (T = x - ((S / w) | 0)),
              (m[S] = y = f ? Math.abs(f === 'y' ? T : v) : xi(v * v + T * T)),
              y > P && (P = y),
              y < b && (b = y)
          r === 'random' && Yi(m),
            (m.max = P - b),
            (m.min = b),
            (m.v = _ =
              (parseFloat(e.amount) ||
                parseFloat(e.each) *
                  (w > _
                    ? _ - 1
                    : f
                    ? f === 'y'
                      ? _ / w
                      : w
                    : Math.max(w, _ / w)) ||
                0) * (r === 'edges' ? -1 : 1)),
            (m.b = _ < 0 ? n - _ : n),
            (m.u = W(e.amount || e.each) || 0),
            (i = i && _ < 0 ? Ji(i) : i)
        }
        return (
          (_ = (m[l] - m.min) / m.max || 0), q(m.b + (i ? i(_) : _) * m.v) + m.u
        )
      }
    )
  },
  We = function (t) {
    var e = Math.pow(10, ((t + '').split('.')[1] || '').length)
    return function (i) {
      var r = q(Math.round(parseFloat(i) / t) * t * e)
      return (r - (r % 1)) / e + (mt(i) ? 0 : W(i))
    }
  },
  qi = function (t, e) {
    var i = G(t),
      r,
      n
    return (
      !i &&
        ft(t) &&
        ((r = i = t.radius || it),
        t.values
          ? ((t = at(t.values)), (n = !mt(t[0])) && (r *= r))
          : (t = We(t.increment))),
      wt(
        e,
        i
          ? z(t)
            ? function (s) {
                return (n = t(s)), Math.abs(n - s) <= r ? n : s
              }
            : function (s) {
                for (
                  var a = parseFloat(n ? s.x : s),
                    o = parseFloat(n ? s.y : 0),
                    f = it,
                    h = 0,
                    c = t.length,
                    l,
                    d;
                  c--;

                )
                  n
                    ? ((l = t[c].x - a), (d = t[c].y - o), (l = l * l + d * d))
                    : (l = Math.abs(t[c] - a)),
                    l < f && ((f = l), (h = c))
                return (
                  (h = !r || f <= r ? t[h] : s),
                  n || h === s || mt(s) ? h : h + W(s)
                )
              }
          : We(t)
      )
    )
  },
  Gi = function (t, e, i, r) {
    return wt(G(t) ? !e : i === !0 ? !!(i = 0) : !r, function () {
      return G(t)
        ? t[~~(Math.random() * t.length)]
        : (i = i || 1e-5) &&
            (r = i < 1 ? Math.pow(10, (i + '').length - 2) : 1) &&
            Math.floor(
              Math.round((t - i / 2 + Math.random() * (e - t + i * 0.99)) / i) *
                i *
                r
            ) / r
    })
  },
  Qr = function () {
    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
      e[i] = arguments[i]
    return function (r) {
      return e.reduce(function (n, s) {
        return s(n)
      }, r)
    }
  },
  Hr = function (t, e) {
    return function (i) {
      return t(parseFloat(i)) + (e || W(i))
    }
  },
  Kr = function (t, e, i) {
    return $i(t, e, 0, 1, i)
  },
  Wi = function (t, e, i) {
    return wt(i, function (r) {
      return t[~~e(r)]
    })
  },
  Zr = function u (t, e, i) {
    var r = e - t
    return G(t)
      ? Wi(t, u(0, t.length), e)
      : wt(i, function (n) {
          return ((r + ((n - t) % r)) % r) + t
        })
  },
  jr = function u (t, e, i) {
    var r = e - t,
      n = r * 2
    return G(t)
      ? Wi(t, u(0, t.length - 1), e)
      : wt(i, function (s) {
          return (s = (n + ((s - t) % n)) % n || 0), t + (s > r ? n - s : s)
        })
  },
  ae = function (t) {
    for (var e = 0, i = '', r, n, s, a; ~(r = t.indexOf('random(', e)); )
      (s = t.indexOf(')', r)),
        (a = t.charAt(r + 7) === '['),
        (n = t.substr(r + 7, s - r - 7).match(a ? Pi : Re)),
        (i +=
          t.substr(e, r - e) + Gi(a ? n : +n[0], a ? 0 : +n[1], +n[2] || 1e-5)),
        (e = s + 1)
    return i + t.substr(e, t.length - e)
  },
  $i = function (t, e, i, r, n) {
    var s = e - t,
      a = r - i
    return wt(n, function (o) {
      return i + (((o - t) / s) * a || 0)
    })
  },
  Jr = function u (t, e, i, r) {
    var n = isNaN(t + e)
      ? 0
      : function (d) {
          return (1 - d) * t + d * e
        }
    if (!n) {
      var s = X(t),
        a = {},
        o,
        f,
        h,
        c,
        l
      if ((i === !0 && (r = 1) && (i = null), s))
        (t = {
          p: t
        }),
          (e = {
            p: e
          })
      else if (G(t) && !G(e)) {
        for (h = [], c = t.length, l = c - 2, f = 1; f < c; f++)
          h.push(u(t[f - 1], t[f]))
        c--,
          (n = function (p) {
            p *= c
            var _ = Math.min(l, ~~p)
            return h[_](p - _)
          }),
          (i = e)
      } else r || (t = At(G(t) ? [] : {}, t))
      if (!h) {
        for (o in e) Ke.call(a, t, o, 'get', e[o])
        n = function (p) {
          return ei(p, a) || (s ? t.p : t)
        }
      }
    }
    return wt(i, n)
  },
  Qi = function (t, e, i) {
    var r = t.labels,
      n = it,
      s,
      a,
      o
    for (s in r)
      (a = r[s] - e),
        a < 0 === !!i && a && n > (a = Math.abs(a)) && ((o = s), (n = a))
    return o
  },
  ot = function (t, e, i) {
    var r = t.vars,
      n = r[e],
      s = N,
      a = t._ctx,
      o,
      f,
      h
    return n
      ? ((o = r[e + 'Params']),
        (f = r.callbackScope || t),
        i && Tt.length && xe(),
        a && (N = a),
        (h = o ? n.apply(f, o) : n.call(f)),
        (N = s),
        h)
      : void 0
  },
  oe = function (t) {
    return (
      gt(t),
      t.scrollTrigger && t.scrollTrigger.kill(!1),
      t.progress() < 1 && ot(t, 'onInterrupt'),
      t
    )
  },
  Gt,
  tn = function (t) {
    t = (!t.name && t.default) || t
    var e = t.name,
      i = z(t),
      r =
        e && !i && t.init
          ? function () {
              this._props = []
            }
          : t,
      n = {
        init: ee,
        render: ei,
        add: Ke,
        kill: gn,
        modifier: mn,
        rawVars: 0
      },
      s = {
        targetTest: 0,
        get: 0,
        getSetter: ti,
        aliases: {},
        register: 0
      }
    if ((Wt(), t !== r)) {
      if (J[e]) return
      nt(r, nt(ve(t, n), s)),
        At(r.prototype, At(n, ve(t, s))),
        (J[(r.prop = e)] = r),
        t.targetTest && (ye.push(r), (Ie[e] = 1)),
        (e =
          (e === 'css' ? 'CSS' : e.charAt(0).toUpperCase() + e.substr(1)) +
          'Plugin')
    }
    ki(e, r), t.register && t.register(et, r, K)
  },
  M = 255,
  ue = {
    aqua: [0, M, M],
    lime: [0, M, 0],
    silver: [192, 192, 192],
    black: [0, 0, 0],
    maroon: [128, 0, 0],
    teal: [0, 128, 128],
    blue: [0, 0, M],
    navy: [0, 0, 128],
    white: [M, M, M],
    olive: [128, 128, 0],
    yellow: [M, M, 0],
    orange: [M, 165, 0],
    gray: [128, 128, 128],
    purple: [128, 0, 128],
    green: [0, 128, 0],
    red: [M, 0, 0],
    pink: [M, 192, 203],
    cyan: [0, M, M],
    transparent: [M, M, M, 0]
  },
  $e = function (t, e, i) {
    return (
      (t += t < 0 ? 1 : t > 1 ? -1 : 0),
      ((t * 6 < 1
        ? e + (i - e) * t * 6
        : t < 0.5
        ? i
        : t * 3 < 2
        ? e + (i - e) * (2 / 3 - t) * 6
        : e) *
        M +
        0.5) |
        0
    )
  },
  Hi = function (t, e, i) {
    var r = t ? (mt(t) ? [t >> 16, (t >> 8) & M, t & M] : 0) : ue.black,
      n,
      s,
      a,
      o,
      f,
      h,
      c,
      l,
      d,
      p
    if (!r) {
      if ((t.substr(-1) === ',' && (t = t.substr(0, t.length - 1)), ue[t]))
        r = ue[t]
      else if (t.charAt(0) === '#') {
        if (
          (t.length < 6 &&
            ((n = t.charAt(1)),
            (s = t.charAt(2)),
            (a = t.charAt(3)),
            (t =
              '#' +
              n +
              n +
              s +
              s +
              a +
              a +
              (t.length === 5 ? t.charAt(4) + t.charAt(4) : ''))),
          t.length === 9)
        )
          return (
            (r = parseInt(t.substr(1, 6), 16)),
            [r >> 16, (r >> 8) & M, r & M, parseInt(t.substr(7), 16) / 255]
          )
        ;(t = parseInt(t.substr(1), 16)), (r = [t >> 16, (t >> 8) & M, t & M])
      } else if (t.substr(0, 3) === 'hsl') {
        if (((r = p = t.match(Re)), !e))
          (o = (+r[0] % 360) / 360),
            (f = +r[1] / 100),
            (h = +r[2] / 100),
            (s = h <= 0.5 ? h * (f + 1) : h + f - h * f),
            (n = h * 2 - s),
            r.length > 3 && (r[3] *= 1),
            (r[0] = $e(o + 1 / 3, n, s)),
            (r[1] = $e(o, n, s)),
            (r[2] = $e(o - 1 / 3, n, s))
        else if (~t.indexOf('='))
          return (r = t.match(wi)), i && r.length < 4 && (r[3] = 1), r
      } else r = t.match(Re) || ue.transparent
      r = r.map(Number)
    }
    return (
      e &&
        !p &&
        ((n = r[0] / M),
        (s = r[1] / M),
        (a = r[2] / M),
        (c = Math.max(n, s, a)),
        (l = Math.min(n, s, a)),
        (h = (c + l) / 2),
        c === l
          ? (o = f = 0)
          : ((d = c - l),
            (f = h > 0.5 ? d / (2 - c - l) : d / (c + l)),
            (o =
              c === n
                ? (s - a) / d + (s < a ? 6 : 0)
                : c === s
                ? (a - n) / d + 2
                : (n - s) / d + 4),
            (o *= 60)),
        (r[0] = ~~(o + 0.5)),
        (r[1] = ~~(f * 100 + 0.5)),
        (r[2] = ~~(h * 100 + 0.5))),
      i && r.length < 4 && (r[3] = 1),
      r
    )
  },
  Ki = function (t) {
    var e = [],
      i = [],
      r = -1
    return (
      t.split(bt).forEach(function (n) {
        var s = n.match(Ut) || []
        e.push.apply(e, s), i.push((r += s.length + 1))
      }),
      (e.c = i),
      e
    )
  },
  Zi = function (t, e, i) {
    var r = '',
      n = (t + r).match(bt),
      s = e ? 'hsla(' : 'rgba(',
      a = 0,
      o,
      f,
      h,
      c
    if (!n) return t
    if (
      ((n = n.map(function (l) {
        return (
          (l = Hi(l, e, 1)) &&
          s +
            (e ? l[0] + ',' + l[1] + '%,' + l[2] + '%,' + l[3] : l.join(',')) +
            ')'
        )
      })),
      i && ((h = Ki(t)), (o = i.c), o.join(r) !== h.c.join(r)))
    )
      for (f = t.replace(bt, '1').split(Ut), c = f.length - 1; a < c; a++)
        r +=
          f[a] +
          (~o.indexOf(a)
            ? n.shift() || s + '0,0,0,0)'
            : (h.length ? h : n.length ? n : i).shift())
    if (!f) for (f = t.split(bt), c = f.length - 1; a < c; a++) r += f[a] + n[a]
    return r + f[c]
  },
  bt = (function () {
    var u =
        '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b',
      t
    for (t in ue) u += '|' + t + '\\b'
    return new RegExp(u + ')', 'gi')
  })(),
  en = /hsl[a]?\(/,
  ji = function (t) {
    var e = t.join(' '),
      i
    if (((bt.lastIndex = 0), bt.test(e)))
      return (
        (i = en.test(e)),
        (t[1] = Zi(t[1], i)),
        (t[0] = Zi(t[0], i, Ki(t[1]))),
        !0
      )
  },
  fe,
  tt = (function () {
    var u = Date.now,
      t = 500,
      e = 33,
      i = u(),
      r = i,
      n = 1e3 / 240,
      s = n,
      a = [],
      o,
      f,
      h,
      c,
      l,
      d,
      p = function _ (m) {
        var g = u() - r,
          x = m === !0,
          v,
          T,
          y,
          S
        if (
          (g > t && (i += g - e),
          (r += g),
          (y = r - i),
          (v = y - s),
          (v > 0 || x) &&
            ((S = ++c.frame),
            (l = y - c.time * 1e3),
            (c.time = y = y / 1e3),
            (s += v + (v >= n ? 4 : n - v)),
            (T = 1)),
          x || (o = f(_)),
          T)
        )
          for (d = 0; d < a.length; d++) a[d](y, l, S, m)
      }
    return (
      (c = {
        time: 0,
        frame: 0,
        tick: function () {
          p(!0)
        },
        deltaRatio: function (m) {
          return l / (1e3 / (m || 60))
        },
        wake: function () {
          Si &&
            (!Fe &&
              vi() &&
              ((rt = Fe = window),
              (ze = rt.document || {}),
              (j.gsap = et),
              (rt.gsapVersions || (rt.gsapVersions = [])).push(et.version),
              Oi(me || rt.GreenSockGlobals || (!rt.gsap && rt) || {}),
              (h = rt.requestAnimationFrame)),
            o && c.sleep(),
            (f =
              h ||
              function (m) {
                return setTimeout(m, (s - c.time * 1e3 + 1) | 0)
              }),
            (fe = 1),
            p(2))
        },
        sleep: function () {
          ;(h ? rt.cancelAnimationFrame : clearTimeout)(o), (fe = 0), (f = ee)
        },
        lagSmoothing: function (m, g) {
          ;(t = m || 1 / C), (e = Math.min(g, t, 0))
        },
        fps: function (m) {
          ;(n = 1e3 / (m || 240)), (s = c.time * 1e3 + n)
        },
        add: function (m, g, x) {
          var v = g
            ? function (T, y, S, P) {
                m(T, y, S, P), c.remove(v)
              }
            : m
          return c.remove(m), a[x ? 'unshift' : 'push'](v), Wt(), v
        },
        remove: function (m, g) {
          ~(g = a.indexOf(m)) && a.splice(g, 1) && d >= g && d--
        },
        _listeners: a
      }),
      c
    )
  })(),
  Wt = function () {
    return !fe && tt.wake()
  },
  k = {},
  rn = /^[\d.\-M][\d.\-,\s]/,
  nn = /["']/g,
  sn = function (t) {
    for (
      var e = {},
        i = t.substr(1, t.length - 3).split(':'),
        r = i[0],
        n = 1,
        s = i.length,
        a,
        o,
        f;
      n < s;
      n++
    )
      (o = i[n]),
        (a = n !== s - 1 ? o.lastIndexOf(',') : o.length),
        (f = o.substr(0, a)),
        (e[r] = isNaN(f) ? f.replace(nn, '').trim() : +f),
        (r = o.substr(a + 1).trim())
    return e
  },
  an = function (t) {
    var e = t.indexOf('(') + 1,
      i = t.indexOf(')'),
      r = t.indexOf('(', e)
    return t.substring(e, ~r && r < i ? t.indexOf(')', i + 1) : i)
  },
  on = function (t) {
    var e = (t + '').split('('),
      i = k[e[0]]
    return i && e.length > 1 && i.config
      ? i.config.apply(
          null,
          ~t.indexOf('{')
            ? [sn(e[1])]
            : an(t)
                .split(',')
                .map(Ri)
        )
      : k._CE && rn.test(t)
      ? k._CE('', t)
      : i
  },
  Ji = function (t) {
    return function (e) {
      return 1 - t(1 - e)
    }
  },
  tr = function u (t, e) {
    for (var i = t._first, r; i; )
      i instanceof $
        ? u(i, e)
        : i.vars.yoyoEase &&
          (!i._yoyo || !i._repeat) &&
          i._yoyo !== e &&
          (i.timeline
            ? u(i.timeline, e)
            : ((r = i._ease),
              (i._ease = i._yEase),
              (i._yEase = r),
              (i._yoyo = e))),
        (i = i._next)
  },
  Et = function (t, e) {
    return (t && (z(t) ? t : k[t] || on(t))) || e
  },
  Ft = function (t, e, i, r) {
    i === void 0 &&
      (i = function (o) {
        return 1 - e(1 - o)
      }),
      r === void 0 &&
        (r = function (o) {
          return o < 0.5 ? e(o * 2) / 2 : 1 - e((1 - o) * 2) / 2
        })
    var n = {
        easeIn: e,
        easeOut: i,
        easeInOut: r
      },
      s
    return (
      H(t, function (a) {
        ;(k[a] = j[a] = n), (k[(s = a.toLowerCase())] = i)
        for (var o in n)
          k[
            s + (o === 'easeIn' ? '.in' : o === 'easeOut' ? '.out' : '.inOut')
          ] = k[a + '.' + o] = n[o]
      }),
      n
    )
  },
  er = function (t) {
    return function (e) {
      return e < 0.5 ? (1 - t(1 - e * 2)) / 2 : 0.5 + t((e - 0.5) * 2) / 2
    }
  },
  Qe = function u (t, e, i) {
    var r = e >= 1 ? e : 1,
      n = (i || (t ? 0.3 : 0.45)) / (e < 1 ? e : 1),
      s = (n / De) * (Math.asin(1 / r) || 0),
      a = function (h) {
        return h === 1 ? 1 : r * Math.pow(2, -10 * h) * Fr((h - s) * n) + 1
      },
      o =
        t === 'out'
          ? a
          : t === 'in'
          ? function (f) {
              return 1 - a(1 - f)
            }
          : er(a)
    return (
      (n = De / n),
      (o.config = function (f, h) {
        return u(t, f, h)
      }),
      o
    )
  },
  He = function u (t, e) {
    e === void 0 && (e = 1.70158)
    var i = function (s) {
        return s ? --s * s * ((e + 1) * s + e) + 1 : 0
      },
      r =
        t === 'out'
          ? i
          : t === 'in'
          ? function (n) {
              return 1 - i(1 - n)
            }
          : er(i)
    return (
      (r.config = function (n) {
        return u(t, n)
      }),
      r
    )
  }
H('Linear,Quad,Cubic,Quart,Quint,Strong', function (u, t) {
  var e = t < 5 ? t + 1 : t
  Ft(
    u + ',Power' + (e - 1),
    t
      ? function (i) {
          return Math.pow(i, e)
        }
      : function (i) {
          return i
        },
    function (i) {
      return 1 - Math.pow(1 - i, e)
    },
    function (i) {
      return i < 0.5 ? Math.pow(i * 2, e) / 2 : 1 - Math.pow((1 - i) * 2, e) / 2
    }
  )
}),
  (k.Linear.easeNone = k.none = k.Linear.easeIn),
  Ft('Elastic', Qe('in'), Qe('out'), Qe()),
  (function (u, t) {
    var e = 1 / t,
      i = 2 * e,
      r = 2.5 * e,
      n = function (a) {
        return a < e
          ? u * a * a
          : a < i
          ? u * Math.pow(a - 1.5 / t, 2) + 0.75
          : a < r
          ? u * (a -= 2.25 / t) * a + 0.9375
          : u * Math.pow(a - 2.625 / t, 2) + 0.984375
      }
    Ft(
      'Bounce',
      function (s) {
        return 1 - n(1 - s)
      },
      n
    )
  })(7.5625, 2.75),
  Ft('Expo', function (u) {
    return u ? Math.pow(2, 10 * (u - 1)) : 0
  }),
  Ft('Circ', function (u) {
    return -(xi(1 - u * u) - 1)
  }),
  Ft('Sine', function (u) {
    return u === 1 ? 1 : -Er(u * Ar) + 1
  }),
  Ft('Back', He('in'), He('out'), He()),
  (k.SteppedEase = k.steps = j.SteppedEase = {
    config: function (t, e) {
      t === void 0 && (t = 1)
      var i = 1 / t,
        r = t + (e ? 0 : 1),
        n = e ? 1 : 0,
        s = 1 - C
      return function (a) {
        return (((r * se(0, s, a)) | 0) + n) * i
      }
    }
  }),
  (Vt.ease = k['quad.out']),
  H(
    'onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt',
    function (u) {
      return (Ve += u + ',' + u + 'Params,')
    }
  )
var ir = function (t, e) {
    ;(this.id = Rr++),
      (t._gsap = this),
      (this.target = t),
      (this.harness = e),
      (this.get = e ? e.get : Di),
      (this.set = e ? e.getSetter : ti)
  },
  $t = (function () {
    function u (e) {
      ;(this.vars = e),
        (this._delay = +e.delay || 0),
        (this._repeat = e.repeat === Infinity ? -2 : e.repeat || 0) &&
          ((this._rDelay = e.repeatDelay || 0),
          (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
        (this._ts = 1),
        qt(this, +e.duration, 1, 1),
        (this.data = e.data),
        N && ((this._ctx = N), N.data.push(this)),
        fe || tt.wake()
    }
    var t = u.prototype
    return (
      (t.delay = function (i) {
        return i || i === 0
          ? (this.parent &&
              this.parent.smoothChildTiming &&
              this.startTime(this._start + i - this._delay),
            (this._delay = i),
            this)
          : this._delay
      }),
      (t.duration = function (i) {
        return arguments.length
          ? this.totalDuration(
              this._repeat > 0 ? i + (i + this._rDelay) * this._repeat : i
            )
          : this.totalDuration() && this._dur
      }),
      (t.totalDuration = function (i) {
        return arguments.length
          ? ((this._dirty = 0),
            qt(
              this,
              this._repeat < 0
                ? i
                : (i - this._repeat * this._rDelay) / (this._repeat + 1)
            ))
          : this._tDur
      }),
      (t.totalTime = function (i, r) {
        if ((Wt(), !arguments.length)) return this._tTime
        var n = this._dp
        if (n && n.smoothChildTiming && this._ts) {
          for (Pe(this, i), !n._dp || n.parent || Ii(n, this); n && n.parent; )
            n.parent._time !==
              n._start +
                (n._ts >= 0
                  ? n._tTime / n._ts
                  : (n.totalDuration() - n._tTime) / -n._ts) &&
              n.totalTime(n._tTime, !0),
              (n = n.parent)
          !this.parent &&
            this._dp.autoRemoveChildren &&
            ((this._ts > 0 && i < this._tDur) ||
              (this._ts < 0 && i > 0) ||
              (!this._tDur && !i)) &&
            ht(this._dp, this, this._start - this._delay)
        }
        return (
          (this._tTime !== i ||
            (!this._dur && !r) ||
            (this._initted && Math.abs(this._zTime) === C) ||
            (!i && !this._initted && (this.add || this._ptLookup))) &&
            (this._ts || (this._pTime = i), Ai(this, i, r)),
          this
        )
      }),
      (t.time = function (i, r) {
        return arguments.length
          ? this.totalTime(
              Math.min(this.totalDuration(), i + Li(this)) %
                (this._dur + this._rDelay) || (i ? this._dur : 0),
              r
            )
          : this._time
      }),
      (t.totalProgress = function (i, r) {
        return arguments.length
          ? this.totalTime(this.totalDuration() * i, r)
          : this.totalDuration()
          ? Math.min(1, this._tTime / this._tDur)
          : this.ratio
      }),
      (t.progress = function (i, r) {
        return arguments.length
          ? this.totalTime(
              this.duration() *
                (this._yoyo && !(this.iteration() & 1) ? 1 - i : i) +
                Li(this),
              r
            )
          : this.duration()
          ? Math.min(1, this._time / this._dur)
          : this.ratio
      }),
      (t.iteration = function (i, r) {
        var n = this.duration() + this._rDelay
        return arguments.length
          ? this.totalTime(this._time + (i - 1) * n, r)
          : this._repeat
          ? Xt(this._tTime, n) + 1
          : 1
      }),
      (t.timeScale = function (i) {
        if (!arguments.length) return this._rts === -C ? 0 : this._rts
        if (this._rts === i) return this
        var r =
          this.parent && this._ts ? we(this.parent._time, this) : this._tTime
        return (
          (this._rts = +i || 0),
          (this._ts = this._ps || i === -C ? 0 : this._rts),
          this.totalTime(se(-this._delay, this._tDur, r), !0),
          be(this),
          Vr(this)
        )
      }),
      (t.paused = function (i) {
        return arguments.length
          ? (this._ps !== i &&
              ((this._ps = i),
              i
                ? ((this._pTime =
                    this._tTime || Math.max(-this._delay, this.rawTime())),
                  (this._ts = this._act = 0))
                : (Wt(),
                  (this._ts = this._rts),
                  this.totalTime(
                    this.parent && !this.parent.smoothChildTiming
                      ? this.rawTime()
                      : this._tTime || this._pTime,
                    this.progress() === 1 &&
                      Math.abs(this._zTime) !== C &&
                      (this._tTime -= C)
                  ))),
            this)
          : this._ps
      }),
      (t.startTime = function (i) {
        if (arguments.length) {
          this._start = i
          var r = this.parent || this._dp
          return (
            r && (r._sort || !this.parent) && ht(r, this, i - this._delay), this
          )
        }
        return this._start
      }),
      (t.endTime = function (i) {
        return (
          this._start +
          (Q(i) ? this.totalDuration() : this.duration()) /
            Math.abs(this._ts || 1)
        )
      }),
      (t.rawTime = function (i) {
        var r = this.parent || this._dp
        return r
          ? i &&
            (!this._ts ||
              (this._repeat && this._time && this.totalProgress() < 1))
            ? this._tTime % (this._dur + this._rDelay)
            : this._ts
            ? we(r.rawTime(i), this)
            : this._tTime
          : this._tTime
      }),
      (t.revert = function (i) {
        i === void 0 && (i = ie)
        var r = ut
        return (
          (ut = i),
          this.timeline && this.timeline.revert(i),
          this.totalTime(-0.01, i.suppressEvents),
          this.data !== 'nested' && gt(this),
          (ut = r),
          this
        )
      }),
      (t.globalTime = function (i) {
        for (var r = this, n = arguments.length ? i : r.rawTime(); r; )
          (n = r._start + n / (r._ts || 1)), (r = r._dp)
        return !this.parent && this.vars.immediateRender ? -1 : n
      }),
      (t.repeat = function (i) {
        return arguments.length
          ? ((this._repeat = i === Infinity ? -2 : i), Vi(this))
          : this._repeat === -2
          ? Infinity
          : this._repeat
      }),
      (t.repeatDelay = function (i) {
        if (arguments.length) {
          var r = this._time
          return (this._rDelay = i), Vi(this), r ? this.time(r) : this
        }
        return this._rDelay
      }),
      (t.yoyo = function (i) {
        return arguments.length ? ((this._yoyo = i), this) : this._yoyo
      }),
      (t.seek = function (i, r) {
        return this.totalTime(st(this, i), Q(r))
      }),
      (t.restart = function (i, r) {
        return this.play().totalTime(i ? -this._delay : 0, Q(r))
      }),
      (t.play = function (i, r) {
        return i != null && this.seek(i, r), this.reversed(!1).paused(!1)
      }),
      (t.reverse = function (i, r) {
        return (
          i != null && this.seek(i || this.totalDuration(), r),
          this.reversed(!0).paused(!1)
        )
      }),
      (t.pause = function (i, r) {
        return i != null && this.seek(i, r), this.paused(!0)
      }),
      (t.resume = function () {
        return this.paused(!1)
      }),
      (t.reversed = function (i) {
        return arguments.length
          ? (!!i !== this.reversed() &&
              this.timeScale(-this._rts || (i ? -C : 0)),
            this)
          : this._rts < 0
      }),
      (t.invalidate = function () {
        return (this._initted = this._act = 0), (this._zTime = -C), this
      }),
      (t.isActive = function () {
        var i = this.parent || this._dp,
          r = this._start,
          n
        return !!(
          !i ||
          (this._ts &&
            this._initted &&
            i.isActive() &&
            (n = i.rawTime(!0)) >= r &&
            n < this.endTime(!0) - C)
        )
      }),
      (t.eventCallback = function (i, r, n) {
        var s = this.vars
        return arguments.length > 1
          ? (r
              ? ((s[i] = r),
                n && (s[i + 'Params'] = n),
                i === 'onUpdate' && (this._onUpdate = r))
              : delete s[i],
            this)
          : s[i]
      }),
      (t.then = function (i) {
        var r = this
        return new Promise(function (n) {
          var s = z(i) ? i : Ei,
            a = function () {
              var f = r.then
              ;(r.then = null),
                z(s) && (s = s(r)) && (s.then || s === r) && (r.then = f),
                n(s),
                (r.then = f)
            }
          ;(r._initted && r.totalProgress() === 1 && r._ts >= 0) ||
          (!r._tTime && r._ts < 0)
            ? a()
            : (r._prom = a)
        })
      }),
      (t.kill = function () {
        oe(this)
      }),
      u
    )
  })()
nt($t.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -C,
  _prom: 0,
  _ps: !1,
  _rts: 1
})
var $ = (function (u) {
  yi(t, u)
  function t (i, r) {
    var n
    return (
      i === void 0 && (i = {}),
      (n = u.call(this, i) || this),
      (n.labels = {}),
      (n.smoothChildTiming = !!i.smoothChildTiming),
      (n.autoRemoveChildren = !!i.autoRemoveChildren),
      (n._sort = Q(i.sortChildren)),
      R && ht(i.parent || R, pt(n), r),
      i.reversed && n.reverse(),
      i.paused && n.paused(!0),
      i.scrollTrigger && Bi(pt(n), i.scrollTrigger),
      n
    )
  }
  var e = t.prototype
  return (
    (e.to = function (r, n, s) {
      return ne(0, arguments, this), this
    }),
    (e.from = function (r, n, s) {
      return ne(1, arguments, this), this
    }),
    (e.fromTo = function (r, n, s, a) {
      return ne(2, arguments, this), this
    }),
    (e.set = function (r, n, s) {
      return (
        (n.duration = 0),
        (n.parent = this),
        re(n).repeatDelay || (n.repeat = 0),
        (n.immediateRender = !!n.immediateRender),
        new V(r, n, st(this, s), 1),
        this
      )
    }),
    (e.call = function (r, n, s) {
      return ht(this, V.delayedCall(0, r, n), s)
    }),
    (e.staggerTo = function (r, n, s, a, o, f, h) {
      return (
        (s.duration = n),
        (s.stagger = s.stagger || a),
        (s.onComplete = f),
        (s.onCompleteParams = h),
        (s.parent = this),
        new V(r, s, st(this, o)),
        this
      )
    }),
    (e.staggerFrom = function (r, n, s, a, o, f, h) {
      return (
        (s.runBackwards = 1),
        (re(s).immediateRender = Q(s.immediateRender)),
        this.staggerTo(r, n, s, a, o, f, h)
      )
    }),
    (e.staggerFromTo = function (r, n, s, a, o, f, h, c) {
      return (
        (a.startAt = s),
        (re(a).immediateRender = Q(a.immediateRender)),
        this.staggerTo(r, n, a, o, f, h, c)
      )
    }),
    (e.render = function (r, n, s) {
      var a = this._time,
        o = this._dirty ? this.totalDuration() : this._tDur,
        f = this._dur,
        h = r <= 0 ? 0 : q(r),
        c = this._zTime < 0 !== r < 0 && (this._initted || !f),
        l,
        d,
        p,
        _,
        m,
        g,
        x,
        v,
        T,
        y,
        S,
        P
      if (
        (this !== R && h > o && r >= 0 && (h = o), h !== this._tTime || s || c)
      ) {
        if (
          (a !== this._time &&
            f &&
            ((h += this._time - a), (r += this._time - a)),
          (l = h),
          (T = this._start),
          (v = this._ts),
          (g = !v),
          c && (f || (a = this._zTime), (r || !n) && (this._zTime = r)),
          this._repeat)
        ) {
          if (
            ((S = this._yoyo),
            (m = f + this._rDelay),
            this._repeat < -1 && r < 0)
          )
            return this.totalTime(m * 100 + r, n, s)
          if (
            ((l = q(h % m)),
            h === o
              ? ((_ = this._repeat), (l = f))
              : ((_ = ~~(h / m)),
                _ && _ === h / m && ((l = f), _--),
                l > f && (l = f)),
            (y = Xt(this._tTime, m)),
            !a && this._tTime && y !== _ && (y = _),
            S && _ & 1 && ((l = f - l), (P = 1)),
            _ !== y && !this._lock)
          ) {
            var b = S && y & 1,
              w = b === (S && _ & 1)
            if (
              (_ < y && (b = !b),
              (a = b ? 0 : f),
              (this._lock = 1),
              (this.render(a || (P ? 0 : q(_ * m)), n, !f)._lock = 0),
              (this._tTime = h),
              !n && this.parent && ot(this, 'onRepeat'),
              this.vars.repeatRefresh && !P && (this.invalidate()._lock = 1),
              (a && a !== this._time) ||
                g !== !this._ts ||
                (this.vars.onRepeat && !this.parent && !this._act))
            )
              return this
            if (
              ((f = this._dur),
              (o = this._tDur),
              w &&
                ((this._lock = 2),
                (a = b ? f : -1e-4),
                this.render(a, !0),
                this.vars.repeatRefresh && !P && this.invalidate()),
              (this._lock = 0),
              !this._ts && !g)
            )
              return this
            tr(this, P)
          }
        }
        if (
          (this._hasPause &&
            !this._forcing &&
            this._lock < 2 &&
            ((x = qr(this, q(a), q(l))), x && (h -= l - (l = x._start))),
          (this._tTime = h),
          (this._time = l),
          (this._act = !v),
          this._initted ||
            ((this._onUpdate = this.vars.onUpdate),
            (this._initted = 1),
            (this._zTime = r),
            (a = 0)),
          !a && l && !n && (ot(this, 'onStart'), this._tTime !== h))
        )
          return this
        if (l >= a && r >= 0)
          for (d = this._first; d; ) {
            if (
              ((p = d._next), (d._act || l >= d._start) && d._ts && x !== d)
            ) {
              if (d.parent !== this) return this.render(r, n, s)
              if (
                (d.render(
                  d._ts > 0
                    ? (l - d._start) * d._ts
                    : (d._dirty ? d.totalDuration() : d._tDur) +
                        (l - d._start) * d._ts,
                  n,
                  s
                ),
                l !== this._time || (!this._ts && !g))
              ) {
                ;(x = 0), p && (h += this._zTime = -C)
                break
              }
            }
            d = p
          }
        else {
          ;(s = s || ut), (d = this._last)
          for (var O = r < 0 ? r : l; d; ) {
            if (((p = d._prev), (d._act || O <= d._end) && d._ts && x !== d)) {
              if (d.parent !== this) return this.render(r, n, s)
              if (
                (d.render(
                  d._ts > 0
                    ? (O - d._start) * d._ts
                    : (d._dirty ? d.totalDuration() : d._tDur) +
                        (O - d._start) * d._ts,
                  n,
                  s
                ),
                l !== this._time || (!this._ts && !g))
              ) {
                ;(x = 0), p && (h += this._zTime = O ? -C : C)
                break
              }
            }
            d = p
          }
        }
        if (
          x &&
          !n &&
          (this.pause(),
          (x.render(l >= a ? 0 : -C)._zTime = l >= a ? 1 : -1),
          this._ts)
        )
          return (this._start = T), be(this), this.render(r, n, s)
        this._onUpdate && !n && ot(this, 'onUpdate', !0),
          ((h === o && this._tTime >= this.totalDuration()) || (!h && a)) &&
            (T === this._start || Math.abs(v) !== Math.abs(this._ts)) &&
              (this._lock ||
                ((r || !f) &&
                  ((h === o && this._ts > 0) || (!h && this._ts < 0)) &&
                  gt(this, 1),
                !n &&
                  !(r < 0 && !a) &&
                  (h || a || !o) &&
                  (ot(
                    this,
                    h === o && r >= 0 ? 'onComplete' : 'onReverseComplete',
                    !0
                  ),
                  this._prom &&
                    !(h < o && this.timeScale() > 0) &&
                    this._prom())))
      }
      return this
    }),
    (e.add = function (r, n) {
      var s = this
      if ((mt(n) || (n = st(this, n, r)), !(r instanceof $t))) {
        if (G(r))
          return (
            r.forEach(function (a) {
              return s.add(a, n)
            }),
            this
          )
        if (X(r)) return this.addLabel(r, n)
        if (z(r)) r = V.delayedCall(0, r)
        else return this
      }
      return this !== r ? ht(this, r, n) : this
    }),
    (e.getChildren = function (r, n, s, a) {
      r === void 0 && (r = !0),
        n === void 0 && (n = !0),
        s === void 0 && (s = !0),
        a === void 0 && (a = -it)
      for (var o = [], f = this._first; f; )
        f._start >= a &&
          (f instanceof V
            ? n && o.push(f)
            : (s && o.push(f), r && o.push.apply(o, f.getChildren(!0, n, s)))),
          (f = f._next)
      return o
    }),
    (e.getById = function (r) {
      for (var n = this.getChildren(1, 1, 1), s = n.length; s--; )
        if (n[s].vars.id === r) return n[s]
    }),
    (e.remove = function (r) {
      return X(r)
        ? this.removeLabel(r)
        : z(r)
        ? this.killTweensOf(r)
        : (Te(this, r),
          r === this._recent && (this._recent = this._last),
          Rt(this))
    }),
    (e.totalTime = function (r, n) {
      return arguments.length
        ? ((this._forcing = 1),
          !this._dp &&
            this._ts &&
            (this._start = q(
              tt.time -
                (this._ts > 0
                  ? r / this._ts
                  : (this.totalDuration() - r) / -this._ts)
            )),
          u.prototype.totalTime.call(this, r, n),
          (this._forcing = 0),
          this)
        : this._tTime
    }),
    (e.addLabel = function (r, n) {
      return (this.labels[r] = st(this, n)), this
    }),
    (e.removeLabel = function (r) {
      return delete this.labels[r], this
    }),
    (e.addPause = function (r, n, s) {
      var a = V.delayedCall(0, n || ee, s)
      return (
        (a.data = 'isPause'), (this._hasPause = 1), ht(this, a, st(this, r))
      )
    }),
    (e.removePause = function (r) {
      var n = this._first
      for (r = st(this, r); n; )
        n._start === r && n.data === 'isPause' && gt(n), (n = n._next)
    }),
    (e.killTweensOf = function (r, n, s) {
      for (var a = this.getTweensOf(r, s), o = a.length; o--; )
        Pt !== a[o] && a[o].kill(r, n)
      return this
    }),
    (e.getTweensOf = function (r, n) {
      for (var s = [], a = at(r), o = this._first, f = mt(n), h; o; )
        o instanceof V
          ? Ir(o._targets, a) &&
            (f
              ? (!Pt || (o._initted && o._ts)) &&
                o.globalTime(0) <= n &&
                o.globalTime(o.totalDuration()) > n
              : !n || o.isActive()) &&
            s.push(o)
          : (h = o.getTweensOf(a, n)).length && s.push.apply(s, h),
          (o = o._next)
      return s
    }),
    (e.tweenTo = function (r, n) {
      n = n || {}
      var s = this,
        a = st(s, r),
        o = n,
        f = o.startAt,
        h = o.onStart,
        c = o.onStartParams,
        l = o.immediateRender,
        d,
        p = V.to(
          s,
          nt(
            {
              ease: n.ease || 'none',
              lazy: !1,
              immediateRender: !1,
              time: a,
              overwrite: 'auto',
              duration:
                n.duration ||
                Math.abs(
                  (a - (f && 'time' in f ? f.time : s._time)) / s.timeScale()
                ) ||
                C,
              onStart: function () {
                if ((s.pause(), !d)) {
                  var m =
                    n.duration ||
                    Math.abs(
                      (a - (f && 'time' in f ? f.time : s._time)) /
                        s.timeScale()
                    )
                  p._dur !== m && qt(p, m, 0, 1).render(p._time, !0, !0),
                    (d = 1)
                }
                h && h.apply(p, c || [])
              }
            },
            n
          )
        )
      return l ? p.render(0) : p
    }),
    (e.tweenFromTo = function (r, n, s) {
      return this.tweenTo(
        n,
        nt(
          {
            startAt: {
              time: st(this, r)
            }
          },
          s
        )
      )
    }),
    (e.recent = function () {
      return this._recent
    }),
    (e.nextLabel = function (r) {
      return r === void 0 && (r = this._time), Qi(this, st(this, r))
    }),
    (e.previousLabel = function (r) {
      return r === void 0 && (r = this._time), Qi(this, st(this, r), 1)
    }),
    (e.currentLabel = function (r) {
      return arguments.length
        ? this.seek(r, !0)
        : this.previousLabel(this._time + C)
    }),
    (e.shiftChildren = function (r, n, s) {
      s === void 0 && (s = 0)
      for (var a = this._first, o = this.labels, f; a; )
        a._start >= s && ((a._start += r), (a._end += r)), (a = a._next)
      if (n) for (f in o) o[f] >= s && (o[f] += r)
      return Rt(this)
    }),
    (e.invalidate = function () {
      var r = this._first
      for (this._lock = 0; r; ) r.invalidate(), (r = r._next)
      return u.prototype.invalidate.call(this)
    }),
    (e.clear = function (r) {
      r === void 0 && (r = !0)
      for (var n = this._first, s; n; ) (s = n._next), this.remove(n), (n = s)
      return (
        this._dp && (this._time = this._tTime = this._pTime = 0),
        r && (this.labels = {}),
        Rt(this)
      )
    }),
    (e.totalDuration = function (r) {
      var n = 0,
        s = this,
        a = s._last,
        o = it,
        f,
        h,
        c
      if (arguments.length)
        return s.timeScale(
          (s._repeat < 0 ? s.duration() : s.totalDuration()) /
            (s.reversed() ? -r : r)
        )
      if (s._dirty) {
        for (c = s.parent; a; )
          (f = a._prev),
            a._dirty && a.totalDuration(),
            (h = a._start),
            h > o && s._sort && a._ts && !s._lock
              ? ((s._lock = 1), (ht(s, a, h - a._delay, 1)._lock = 0))
              : (o = h),
            h < 0 &&
              a._ts &&
              ((n -= h),
              ((!c && !s._dp) || (c && c.smoothChildTiming)) &&
                ((s._start += h / s._ts), (s._time -= h), (s._tTime -= h)),
              s.shiftChildren(-h, !1, -Infinity),
              (o = 0)),
            a._end > n && a._ts && (n = a._end),
            (a = f)
        qt(s, s === R && s._time > n ? s._time : n, 1, 1), (s._dirty = 0)
      }
      return s._tDur
    }),
    (t.updateRoot = function (r) {
      if ((R._ts && (Ai(R, we(r, R)), (Ci = tt.frame)), tt.frame >= Mi)) {
        Mi += Z.autoSleep || 120
        var n = R._first
        if ((!n || !n._ts) && Z.autoSleep && tt._listeners.length < 2) {
          for (; n && !n._ts; ) n = n._next
          n || tt.sleep()
        }
      }
    }),
    t
  )
})($t)
nt($.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
})
var un = function (t, e, i, r, n, s, a) {
    var o = new K(this._pt, t, e, 0, 1, ur, null, n),
      f = 0,
      h = 0,
      c,
      l,
      d,
      p,
      _,
      m,
      g,
      x
    for (
      o.b = i,
        o.e = r,
        i += '',
        r += '',
        (g = ~r.indexOf('random(')) && (r = ae(r)),
        s && ((x = [i, r]), s(x, t, e), (i = x[0]), (r = x[1])),
        l = i.match(Ee) || [];
      (c = Ee.exec(r));

    )
      (p = c[0]),
        (_ = r.substring(f, c.index)),
        d ? (d = (d + 1) % 5) : _.substr(-5) === 'rgba(' && (d = 1),
        p !== l[h++] &&
          ((m = parseFloat(l[h - 1]) || 0),
          (o._pt = {
            _next: o._pt,
            p: _ || h === 1 ? _ : ',',
            s: m,
            c: p.charAt(1) === '=' ? Yt(m, p) - m : parseFloat(p) - m,
            m: d && d < 4 ? Math.round : 0
          }),
          (f = Ee.lastIndex))
    return (
      (o.c = f < r.length ? r.substring(f, r.length) : ''),
      (o.fp = a),
      (bi.test(r) || g) && (o.e = 0),
      (this._pt = o),
      o
    )
  },
  Ke = function (t, e, i, r, n, s, a, o, f, h) {
    z(r) && (r = r(n || 0, t, s))
    var c = t[e],
      l =
        i !== 'get'
          ? i
          : z(c)
          ? f
            ? t[
                e.indexOf('set') || !z(t['get' + e.substr(3)])
                  ? e
                  : 'get' + e.substr(3)
              ](f)
            : t[e]()
          : c,
      d = z(c) ? (f ? cn : ar) : Je,
      p
    if (
      (X(r) &&
        (~r.indexOf('random(') && (r = ae(r)),
        r.charAt(1) === '=' &&
          ((p = Yt(l, r) + (W(l) || 0)), (p || p === 0) && (r = p))),
      !h || l !== r || Ze)
    )
      return !isNaN(l * r) && r !== ''
        ? ((p = new K(
            this._pt,
            t,
            e,
            +l || 0,
            r - (l || 0),
            typeof c == 'boolean' ? pn : or,
            0,
            d
          )),
          f && (p.fp = f),
          a && p.modifier(a, this, t),
          (this._pt = p))
        : (!c && !(e in t) && Le(e, r),
          un.call(this, t, e, l, r, d, o || Z.stringFilter, f))
  },
  fn = function (t, e, i, r, n) {
    if (
      (z(t) && (t = he(t, n, e, i, r)),
      !ft(t) || (t.style && t.nodeType) || G(t) || Ti(t))
    )
      return X(t) ? he(t, n, e, i, r) : t
    var s = {},
      a
    for (a in t) s[a] = he(t[a], n, e, i, r)
    return s
  },
  rr = function (t, e, i, r, n, s) {
    var a, o, f, h
    if (
      J[t] &&
      (a = new J[t]()).init(
        n,
        a.rawVars ? e[t] : fn(e[t], r, n, s, i),
        i,
        r,
        s
      ) !== !1 &&
      ((i._pt = o = new K(i._pt, n, t, 0, 1, a.render, a, 0, a.priority)),
      i !== Gt)
    )
      for (f = i._ptLookup[i._targets.indexOf(n)], h = a._props.length; h--; )
        f[a._props[h]] = o
    return a
  },
  Pt,
  Ze,
  je = function u (t, e) {
    var i = t.vars,
      r = i.ease,
      n = i.startAt,
      s = i.immediateRender,
      a = i.lazy,
      o = i.onUpdate,
      f = i.onUpdateParams,
      h = i.callbackScope,
      c = i.runBackwards,
      l = i.yoyoEase,
      d = i.keyframes,
      p = i.autoRevert,
      _ = t._dur,
      m = t._startAt,
      g = t._targets,
      x = t.parent,
      v = x && x.data === 'nested' ? x.parent._targets : g,
      T = t._overwrite === 'auto' && !Me,
      y = t.timeline,
      S,
      P,
      b,
      w,
      O,
      D,
      E,
      A,
      F,
      Y,
      U,
      B,
      ct
    if (
      (y && (!d || !r) && (r = 'none'),
      (t._ease = Et(r, Vt.ease)),
      (t._yEase = l ? Ji(Et(l === !0 ? r : l, Vt.ease)) : 0),
      l &&
        t._yoyo &&
        !t._repeat &&
        ((l = t._yEase), (t._yEase = t._ease), (t._ease = l)),
      (t._from = !y && !!i.runBackwards),
      !y || (d && !i.stagger))
    ) {
      if (
        ((A = g[0] ? Dt(g[0]).harness : 0),
        (B = A && i[A.prop]),
        (S = ve(i, Ie)),
        m && (m.revert(c && _ ? ie : Lr), (m._lazy = 0)),
        n)
      ) {
        if (
          (gt(
            (t._startAt = V.set(
              g,
              nt(
                {
                  data: 'isStart',
                  overwrite: !1,
                  parent: x,
                  immediateRender: !0,
                  lazy: Q(a),
                  startAt: null,
                  delay: 0,
                  onUpdate: o,
                  onUpdateParams: f,
                  callbackScope: h,
                  stagger: 0
                },
                n
              )
            ))
          ),
          e < 0 && (ut || (!s && !p)) && t._startAt.revert(ie),
          s && _ && e <= 0)
        ) {
          e && (t._zTime = e)
          return
        }
      } else if (c && _ && !m) {
        if (
          (e && (s = !1),
          (b = nt(
            {
              overwrite: !1,
              data: 'isFromStart',
              lazy: s && Q(a),
              immediateRender: s,
              stagger: 0,
              parent: x
            },
            S
          )),
          B && (b[A.prop] = B),
          gt((t._startAt = V.set(g, b))),
          e < 0 && (ut ? t._startAt.revert(ie) : t._startAt.render(-1, !0)),
          (t._zTime = e),
          !s)
        )
          u(t._startAt, C)
        else if (!e) return
      }
      for (
        t._pt = t._ptCache = 0, a = (_ && Q(a)) || (a && !_), P = 0;
        P < g.length;
        P++
      ) {
        if (
          ((O = g[P]),
          (E = O._gsap || Ue(g)[P]._gsap),
          (t._ptLookup[P] = Y = {}),
          Be[E.id] && Tt.length && xe(),
          (U = v === g ? P : v.indexOf(O)),
          A &&
            (F = new A()).init(O, B || S, t, U, v) !== !1 &&
            ((t._pt = w = new K(
              t._pt,
              O,
              F.name,
              0,
              1,
              F.render,
              F,
              0,
              F.priority
            )),
            F._props.forEach(function (Nt) {
              Y[Nt] = w
            }),
            F.priority && (D = 1)),
          !A || B)
        )
          for (b in S)
            J[b] && (F = rr(b, S, t, U, O, v))
              ? F.priority && (D = 1)
              : (Y[b] = w = Ke.call(
                  t,
                  O,
                  b,
                  'get',
                  S[b],
                  U,
                  v,
                  0,
                  i.stringFilter
                ))
        t._op && t._op[P] && t.kill(O, t._op[P]),
          T &&
            t._pt &&
            ((Pt = t),
            R.killTweensOf(O, Y, t.globalTime(e)),
            (ct = !t.parent),
            (Pt = 0)),
          t._pt && a && (Be[E.id] = 1)
      }
      D && fr(t), t._onInit && t._onInit(t)
    }
    ;(t._onUpdate = o),
      (t._initted = (!t._op || t._pt) && !ct),
      d && e <= 0 && y.render(it, !0, !0)
  },
  hn = function (t, e, i, r, n, s, a) {
    var o = ((t._pt && t._ptCache) || (t._ptCache = {}))[e],
      f,
      h,
      c,
      l
    if (!o)
      for (
        o = t._ptCache[e] = [], c = t._ptLookup, l = t._targets.length;
        l--;

      ) {
        if (((f = c[l][e]), f && f.d && f.d._pt))
          for (f = f.d._pt; f && f.p !== e && f.fp !== e; ) f = f._next
        if (!f) return (Ze = 1), (t.vars[e] = '+=0'), je(t, a), (Ze = 0), 1
        o.push(f)
      }
    for (l = o.length; l--; )
      (h = o[l]),
        (f = h._pt || h),
        (f.s = (r || r === 0) && !n ? r : f.s + (r || 0) + s * f.c),
        (f.c = i - f.s),
        h.e && (h.e = I(i) + W(h.e)),
        h.b && (h.b = f.s + W(h.b))
  },
  _n = function (t, e) {
    var i = t[0] ? Dt(t[0]).harness : 0,
      r = i && i.aliases,
      n,
      s,
      a,
      o
    if (!r) return e
    n = At({}, e)
    for (s in r)
      if (s in n) for (o = r[s].split(','), a = o.length; a--; ) n[o[a]] = n[s]
    return n
  },
  ln = function (t, e, i, r) {
    var n = e.ease || r || 'power1.inOut',
      s,
      a
    if (G(e))
      (a = i[t] || (i[t] = [])),
        e.forEach(function (o, f) {
          return a.push({
            t: (f / (e.length - 1)) * 100,
            v: o,
            e: n
          })
        })
    else
      for (s in e)
        (a = i[s] || (i[s] = [])),
          s === 'ease' ||
            a.push({
              t: parseFloat(t),
              v: e[s],
              e: n
            })
  },
  he = function (t, e, i, r, n) {
    return z(t) ? t.call(e, i, r, n) : X(t) && ~t.indexOf('random(') ? ae(t) : t
  },
  nr = Ve + 'repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert',
  sr = {}
H(nr + ',id,stagger,delay,duration,paused,scrollTrigger', function (u) {
  return (sr[u] = 1)
})
var V = (function (u) {
  yi(t, u)
  function t (i, r, n, s) {
    var a
    typeof r == 'number' && ((n.duration = r), (r = n), (n = null)),
      (a = u.call(this, s ? r : re(r)) || this)
    var o = a.vars,
      f = o.duration,
      h = o.delay,
      c = o.immediateRender,
      l = o.stagger,
      d = o.overwrite,
      p = o.keyframes,
      _ = o.defaults,
      m = o.scrollTrigger,
      g = o.yoyoEase,
      x = r.parent || R,
      v = (G(i) || Ti(i) ? mt(i[0]) : 'length' in r) ? [i] : at(i),
      T,
      y,
      S,
      P,
      b,
      w,
      O,
      D
    if (
      ((a._targets = v.length
        ? Ue(v)
        : ge(
            'GSAP target ' + i + ' not found. https://greensock.com',
            !Z.nullTargetWarn
          ) || []),
      (a._ptLookup = []),
      (a._overwrite = d),
      p || l || pe(f) || pe(h))
    ) {
      if (
        ((r = a.vars),
        (T = a.timeline = new $({
          data: 'nested',
          defaults: _ || {}
        })),
        T.kill(),
        (T.parent = T._dp = pt(a)),
        (T._start = 0),
        l || pe(f) || pe(h))
      ) {
        if (((P = v.length), (O = l && Xi(l)), ft(l)))
          for (b in l) ~nr.indexOf(b) && (D || (D = {}), (D[b] = l[b]))
        for (y = 0; y < P; y++)
          (S = ve(r, sr)),
            (S.stagger = 0),
            g && (S.yoyoEase = g),
            D && At(S, D),
            (w = v[y]),
            (S.duration = +he(f, pt(a), y, w, v)),
            (S.delay = (+he(h, pt(a), y, w, v) || 0) - a._delay),
            !l &&
              P === 1 &&
              S.delay &&
              ((a._delay = h = S.delay), (a._start += h), (S.delay = 0)),
            T.to(w, S, O ? O(y, w, v) : 0),
            (T._ease = k.none)
        T.duration() ? (f = h = 0) : (a.timeline = 0)
      } else if (p) {
        re(
          nt(T.vars.defaults, {
            ease: 'none'
          })
        ),
          (T._ease = Et(p.ease || r.ease || 'none'))
        var E = 0,
          A,
          F,
          Y
        if (G(p))
          p.forEach(function (U) {
            return T.to(v, U, '>')
          }),
            T.duration()
        else {
          S = {}
          for (b in p)
            b === 'ease' || b === 'easeEach' || ln(b, p[b], S, p.easeEach)
          for (b in S)
            for (
              A = S[b].sort(function (U, B) {
                return U.t - B.t
              }),
                E = 0,
                y = 0;
              y < A.length;
              y++
            )
              (F = A[y]),
                (Y = {
                  ease: F.e,
                  duration: ((F.t - (y ? A[y - 1].t : 0)) / 100) * f
                }),
                (Y[b] = F.v),
                T.to(v, Y, E),
                (E += Y.duration)
          T.duration() < f &&
            T.to(
              {},
              {
                duration: f - T.duration()
              }
            )
        }
      }
      f || a.duration((f = T.duration()))
    } else a.timeline = 0
    return (
      d === !0 && !Me && ((Pt = pt(a)), R.killTweensOf(v), (Pt = 0)),
      ht(x, pt(a), n),
      r.reversed && a.reverse(),
      r.paused && a.paused(!0),
      (c ||
        (!f &&
          !p &&
          a._start === q(x._time) &&
          Q(c) &&
          Ur(pt(a)) &&
          x.data !== 'nested')) &&
        ((a._tTime = -C), a.render(Math.max(0, -h))),
      m && Bi(pt(a), m),
      a
    )
  }
  var e = t.prototype
  return (
    (e.render = function (r, n, s) {
      var a = this._time,
        o = this._tDur,
        f = this._dur,
        h = r < 0,
        c = r > o - C && !h ? o : r < C ? 0 : r,
        l,
        d,
        p,
        _,
        m,
        g,
        x,
        v,
        T
      if (!f) Xr(this, r, n, s)
      else if (
        c !== this._tTime ||
        !r ||
        s ||
        (!this._initted && this._tTime) ||
        (this._startAt && this._zTime < 0 !== h)
      ) {
        if (((l = c), (v = this.timeline), this._repeat)) {
          if (((_ = f + this._rDelay), this._repeat < -1 && h))
            return this.totalTime(_ * 100 + r, n, s)
          if (
            ((l = q(c % _)),
            c === o
              ? ((p = this._repeat), (l = f))
              : ((p = ~~(c / _)),
                p && p === c / _ && ((l = f), p--),
                l > f && (l = f)),
            (g = this._yoyo && p & 1),
            g && ((T = this._yEase), (l = f - l)),
            (m = Xt(this._tTime, _)),
            l === a && !s && this._initted)
          )
            return (this._tTime = c), this
          p !== m &&
            (v && this._yEase && tr(v, g),
            this.vars.repeatRefresh &&
              !g &&
              !this._lock &&
              ((this._lock = s = 1),
              (this.render(q(_ * p), !0).invalidate()._lock = 0)))
        }
        if (!this._initted) {
          if (Ni(this, h ? r : l, s, n)) return (this._tTime = 0), this
          if (a !== this._time) return this
          if (f !== this._dur) return this.render(r, n, s)
        }
        if (
          ((this._tTime = c),
          (this._time = l),
          !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
          (this.ratio = x = (T || this._ease)(l / f)),
          this._from && (this.ratio = x = 1 - x),
          l && !a && !n && (ot(this, 'onStart'), this._tTime !== c))
        )
          return this
        for (d = this._pt; d; ) d.r(x, d.d), (d = d._next)
        ;(v &&
          v.render(
            r < 0 ? r : !l && g ? -C : v._dur * v._ease(l / this._dur),
            n,
            s
          )) ||
          (this._startAt && (this._zTime = r)),
          this._onUpdate &&
            !n &&
            (h && Ye(this, r, n, s), ot(this, 'onUpdate')),
          this._repeat &&
            p !== m &&
            this.vars.onRepeat &&
            !n &&
            this.parent &&
            ot(this, 'onRepeat'),
          (c === this._tDur || !c) &&
            this._tTime === c &&
            (h && !this._onUpdate && Ye(this, r, !0, !0),
            (r || !f) &&
              ((c === this._tDur && this._ts > 0) || (!c && this._ts < 0)) &&
              gt(this, 1),
            !n &&
              !(h && !a) &&
              (c || a) &&
              (ot(this, c === o ? 'onComplete' : 'onReverseComplete', !0),
              this._prom && !(c < o && this.timeScale() > 0) && this._prom()))
      }
      return this
    }),
    (e.targets = function () {
      return this._targets
    }),
    (e.invalidate = function () {
      return (
        (this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0),
        (this._ptLookup = []),
        this.timeline && this.timeline.invalidate(),
        u.prototype.invalidate.call(this)
      )
    }),
    (e.resetTo = function (r, n, s, a) {
      fe || tt.wake(), this._ts || this.play()
      var o = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
        f
      return (
        this._initted || je(this, o),
        (f = this._ease(o / this._dur)),
        hn(this, r, n, s, a, f, o)
          ? this.resetTo(r, n, s, a)
          : (Pe(this, 0),
            this.parent ||
              zi(
                this._dp,
                this,
                '_first',
                '_last',
                this._dp._sort ? '_start' : 0
              ),
            this.render(0))
      )
    }),
    (e.kill = function (r, n) {
      if ((n === void 0 && (n = 'all'), !r && (!n || n === 'all')))
        return (this._lazy = this._pt = 0), this.parent ? oe(this) : this
      if (this.timeline) {
        var s = this.timeline.totalDuration()
        return (
          this.timeline.killTweensOf(r, n, Pt && Pt.vars.overwrite !== !0)
            ._first || oe(this),
          this.parent &&
            s !== this.timeline.totalDuration() &&
            qt(this, (this._dur * this.timeline._tDur) / s, 0, 1),
          this
        )
      }
      var a = this._targets,
        o = r ? at(r) : a,
        f = this._ptLookup,
        h = this._pt,
        c,
        l,
        d,
        p,
        _,
        m,
        g
      if ((!n || n === 'all') && Nr(a, o))
        return n === 'all' && (this._pt = 0), oe(this)
      for (
        c = this._op = this._op || [],
          n !== 'all' &&
            (X(n) &&
              ((_ = {}),
              H(n, function (x) {
                return (_[x] = 1)
              }),
              (n = _)),
            (n = _n(a, n))),
          g = a.length;
        g--;

      )
        if (~o.indexOf(a[g])) {
          ;(l = f[g]),
            n === 'all'
              ? ((c[g] = n), (p = l), (d = {}))
              : ((d = c[g] = c[g] || {}), (p = n))
          for (_ in p)
            (m = l && l[_]),
              m &&
                ((!('kill' in m.d) || m.d.kill(_) === !0) && Te(this, m, '_pt'),
                delete l[_]),
              d !== 'all' && (d[_] = 1)
        }
      return this._initted && !this._pt && h && oe(this), this
    }),
    (t.to = function (r, n) {
      return new t(r, n, arguments[2])
    }),
    (t.from = function (r, n) {
      return ne(1, arguments)
    }),
    (t.delayedCall = function (r, n, s, a) {
      return new t(n, 0, {
        immediateRender: !1,
        lazy: !1,
        overwrite: !1,
        delay: r,
        onComplete: n,
        onReverseComplete: n,
        onCompleteParams: s,
        onReverseCompleteParams: s,
        callbackScope: a
      })
    }),
    (t.fromTo = function (r, n, s) {
      return ne(2, arguments)
    }),
    (t.set = function (r, n) {
      return (n.duration = 0), n.repeatDelay || (n.repeat = 0), new t(r, n)
    }),
    (t.killTweensOf = function (r, n, s) {
      return R.killTweensOf(r, n, s)
    }),
    t
  )
})($t)
nt(V.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}),
  H('staggerTo,staggerFrom,staggerFromTo', function (u) {
    V[u] = function () {
      var t = new $(),
        e = qe.call(arguments, 0)
      return e.splice(u === 'staggerFromTo' ? 5 : 4, 0, 0), t[u].apply(t, e)
    }
  })
var Je = function (t, e, i) {
    return (t[e] = i)
  },
  ar = function (t, e, i) {
    return t[e](i)
  },
  cn = function (t, e, i, r) {
    return t[e](r.fp, i)
  },
  dn = function (t, e, i) {
    return t.setAttribute(e, i)
  },
  ti = function (t, e) {
    return z(t[e]) ? ar : Ae(t[e]) && t.setAttribute ? dn : Je
  },
  or = function (t, e) {
    return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e6) / 1e6, e)
  },
  pn = function (t, e) {
    return e.set(e.t, e.p, !!(e.s + e.c * t), e)
  },
  ur = function (t, e) {
    var i = e._pt,
      r = ''
    if (!t && e.b) r = e.b
    else if (t === 1 && e.e) r = e.e
    else {
      for (; i; )
        (r =
          i.p +
          (i.m ? i.m(i.s + i.c * t) : Math.round((i.s + i.c * t) * 1e4) / 1e4) +
          r),
          (i = i._next)
      r += e.c
    }
    e.set(e.t, e.p, r, e)
  },
  ei = function (t, e) {
    for (var i = e._pt; i; ) i.r(t, i.d), (i = i._next)
  },
  mn = function (t, e, i, r) {
    for (var n = this._pt, s; n; )
      (s = n._next), n.p === r && n.modifier(t, e, i), (n = s)
  },
  gn = function (t) {
    for (var e = this._pt, i, r; e; )
      (r = e._next),
        (e.p === t && !e.op) || e.op === t
          ? Te(this, e, '_pt')
          : e.dep || (i = 1),
        (e = r)
    return !i
  },
  yn = function (t, e, i, r) {
    r.mSet(t, e, r.m.call(r.tween, i, r.mt), r)
  },
  fr = function (t) {
    for (var e = t._pt, i, r, n, s; e; ) {
      for (i = e._next, r = n; r && r.pr > e.pr; ) r = r._next
      ;(e._prev = r ? r._prev : s) ? (e._prev._next = e) : (n = e),
        (e._next = r) ? (r._prev = e) : (s = e),
        (e = i)
    }
    t._pt = n
  },
  K = (function () {
    function u (e, i, r, n, s, a, o, f, h) {
      ;(this.t = i),
        (this.s = n),
        (this.c = s),
        (this.p = r),
        (this.r = a || or),
        (this.d = o || this),
        (this.set = f || Je),
        (this.pr = h || 0),
        (this._next = e),
        e && (e._prev = this)
    }
    var t = u.prototype
    return (
      (t.modifier = function (i, r, n) {
        ;(this.mSet = this.mSet || this.set),
          (this.set = yn),
          (this.m = i),
          (this.mt = n),
          (this.tween = r)
      }),
      u
    )
  })()
H(
  Ve +
    'parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger',
  function (u) {
    return (Ie[u] = 1)
  }
),
  (j.TweenMax = j.TweenLite = V),
  (j.TimelineLite = j.TimelineMax = $),
  (R = new $({
    sortChildren: !1,
    defaults: Vt,
    autoRemoveChildren: !0,
    id: 'root',
    smoothChildTiming: !0
  })),
  (Z.stringFilter = ji)
var Qt = [],
  Se = {},
  xn = [],
  hr = 0,
  ii = function (t) {
    return (Se[t] || xn).map(function (e) {
      return e()
    })
  },
  ri = function () {
    var t = Date.now(),
      e = []
    t - hr > 2 &&
      (ii('matchMediaInit'),
      Qt.forEach(function (i) {
        var r = i.queries,
          n = i.conditions,
          s,
          a,
          o,
          f
        for (a in r)
          (s = rt.matchMedia(r[a]).matches),
            s && (o = 1),
            s !== n[a] && ((n[a] = s), (f = 1))
        f && (i.revert(), o && e.push(i))
      }),
      ii('matchMediaRevert'),
      e.forEach(function (i) {
        return i.onMatch(i)
      }),
      (hr = t),
      ii('matchMedia'))
  },
  _r = (function () {
    function u (e, i) {
      ;(this.selector = i && Ge(i)),
        (this.data = []),
        (this._r = []),
        (this.isReverted = !1),
        e && this.add(e)
    }
    var t = u.prototype
    return (
      (t.add = function (i, r, n) {
        z(i) && ((n = r), (r = i), (i = z))
        var s = this,
          a = function () {
            var f = N,
              h = s.selector,
              c
            return (
              f && f.data.push(s),
              n && (s.selector = Ge(n)),
              (N = s),
              (c = r.apply(s, arguments)),
              z(c) && s._r.push(c),
              (N = f),
              (s.selector = h),
              (s.isReverted = !1),
              c
            )
          }
        return (s.last = a), i === z ? a(s) : i ? (s[i] = a) : a
      }),
      (t.ignore = function (i) {
        var r = N
        ;(N = null), i(this), (N = r)
      }),
      (t.getTweens = function () {
        var i = []
        return (
          this.data.forEach(function (r) {
            return r instanceof u
              ? i.push.apply(i, r.getTweens())
              : r instanceof V &&
                  r._targets[0] !== r.vars.onComplete &&
                  i.push(r)
          }),
          i
        )
      }),
      (t.clear = function () {
        this._r.length = this.data.length = 0
      }),
      (t.kill = function (i, r) {
        var n = this
        if (
          (i
            ? (this.getTweens()
                .map(function (a) {
                  return {
                    g: a.globalTime(0),
                    t: a
                  }
                })
                .sort(function (a, o) {
                  return o.g - a.g || -1
                })
                .forEach(function (a) {
                  return a.t.revert(i)
                }),
              this.data.forEach(function (a) {
                return !(a instanceof $t) && a.revert && a.revert(i)
              }),
              this._r.forEach(function (a) {
                return a(i, n)
              }),
              (this.isReverted = !0))
            : this.data.forEach(function (a) {
                return a.kill && a.kill()
              }),
          this.clear(),
          r)
        ) {
          var s = Qt.indexOf(this)
          !!~s && Qt.splice(s, 1)
        }
      }),
      (t.revert = function (i) {
        this.kill(i || {})
      }),
      u
    )
  })(),
  vn = (function () {
    function u (e) {
      ;(this.contexts = []), (this.scope = e)
    }
    var t = u.prototype
    return (
      (t.add = function (i, r, n) {
        ft(i) ||
          (i = {
            matches: i
          })
        var s = new _r(0, n || this.scope),
          a = (s.conditions = {}),
          o,
          f,
          h
        this.contexts.push(s), (r = s.add('onMatch', r)), (s.queries = i)
        for (f in i)
          f === 'all'
            ? (h = 1)
            : ((o = rt.matchMedia(i[f])),
              o &&
                (Qt.indexOf(s) < 0 && Qt.push(s),
                (a[f] = o.matches) && (h = 1),
                o.addListener
                  ? o.addListener(ri)
                  : o.addEventListener('change', ri)))
        return h && r(s), this
      }),
      (t.revert = function (i) {
        this.kill(i || {})
      }),
      (t.kill = function (i) {
        this.contexts.forEach(function (r) {
          return r.kill(i, !0)
        })
      }),
      u
    )
  })(),
  Oe = {
    registerPlugin: function () {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
        e[i] = arguments[i]
      e.forEach(function (r) {
        return tn(r)
      })
    },
    timeline: function (t) {
      return new $(t)
    },
    getTweensOf: function (t, e) {
      return R.getTweensOf(t, e)
    },
    getProperty: function (t, e, i, r) {
      X(t) && (t = at(t)[0])
      var n = Dt(t || {}).get,
        s = i ? Ei : Ri
      return (
        i === 'native' && (i = ''),
        t &&
          (e
            ? s(((J[e] && J[e].get) || n)(t, e, i, r))
            : function (a, o, f) {
                return s(((J[a] && J[a].get) || n)(t, a, o, f))
              })
      )
    },
    quickSetter: function (t, e, i) {
      if (((t = at(t)), t.length > 1)) {
        var r = t.map(function (h) {
            return et.quickSetter(h, e, i)
          }),
          n = r.length
        return function (h) {
          for (var c = n; c--; ) r[c](h)
        }
      }
      t = t[0] || {}
      var s = J[e],
        a = Dt(t),
        o = (a.harness && (a.harness.aliases || {})[e]) || e,
        f = s
          ? function (h) {
              var c = new s()
              ;(Gt._pt = 0),
                c.init(t, i ? h + i : h, Gt, 0, [t]),
                c.render(1, c),
                Gt._pt && ei(1, Gt)
            }
          : a.set(t, o)
      return s
        ? f
        : function (h) {
            return f(t, o, i ? h + i : h, a, 1)
          }
    },
    quickTo: function (t, e, i) {
      var r,
        n = et.to(
          t,
          At(((r = {}), (r[e] = '+=0.1'), (r.paused = !0), r), i || {})
        ),
        s = function (o, f, h) {
          return n.resetTo(e, o, f, h)
        }
      return (s.tween = n), s
    },
    isTweening: function (t) {
      return R.getTweensOf(t, !0).length > 0
    },
    defaults: function (t) {
      return t && t.ease && (t.ease = Et(t.ease, Vt.ease)), Fi(Vt, t || {})
    },
    config: function (t) {
      return Fi(Z, t || {})
    },
    registerEffect: function (t) {
      var e = t.name,
        i = t.effect,
        r = t.plugins,
        n = t.defaults,
        s = t.extendTimeline
      ;(r || '').split(',').forEach(function (a) {
        return (
          a && !J[a] && !j[a] && ge(e + ' effect requires ' + a + ' plugin.')
        )
      }),
        (Ne[e] = function (a, o, f) {
          return i(at(a), nt(o || {}, n), f)
        }),
        s &&
          ($.prototype[e] = function (a, o, f) {
            return this.add(Ne[e](a, ft(o) ? o : (f = o) && {}, this), f)
          })
    },
    registerEase: function (t, e) {
      k[t] = Et(e)
    },
    parseEase: function (t, e) {
      return arguments.length ? Et(t, e) : k
    },
    getById: function (t) {
      return R.getById(t)
    },
    exportRoot: function (t, e) {
      t === void 0 && (t = {})
      var i = new $(t),
        r,
        n
      for (
        i.smoothChildTiming = Q(t.smoothChildTiming),
          R.remove(i),
          i._dp = 0,
          i._time = i._tTime = R._time,
          r = R._first;
        r;

      )
        (n = r._next),
          (e ||
            !(
              !r._dur &&
              r instanceof V &&
              r.vars.onComplete === r._targets[0]
            )) &&
            ht(i, r, r._start - r._delay),
          (r = n)
      return ht(R, i, 0), i
    },
    context: function (t, e) {
      return t ? new _r(t, e) : N
    },
    matchMedia: function (t) {
      return new vn(t)
    },
    matchMediaRefresh: function () {
      return (
        Qt.forEach(function (t) {
          var e = t.conditions,
            i,
            r
          for (r in e) e[r] && ((e[r] = !1), (i = 1))
          i && t.revert()
        }) || ri()
      )
    },
    addEventListener: function (t, e) {
      var i = Se[t] || (Se[t] = [])
      ~i.indexOf(e) || i.push(e)
    },
    removeEventListener: function (t, e) {
      var i = Se[t],
        r = i && i.indexOf(e)
      r >= 0 && i.splice(r, 1)
    },
    utils: {
      wrap: Zr,
      wrapYoyo: jr,
      distribute: Xi,
      random: Gi,
      snap: qi,
      normalize: Kr,
      getUnit: W,
      clamp: Wr,
      splitColor: Hi,
      toArray: at,
      selector: Ge,
      mapRange: $i,
      pipe: Qr,
      unitize: Hr,
      interpolate: Jr,
      shuffle: Yi
    },
    install: Oi,
    effects: Ne,
    ticker: tt,
    updateRoot: $.updateRoot,
    plugins: J,
    globalTimeline: R,
    core: {
      PropTween: K,
      globals: ki,
      Tween: V,
      Timeline: $,
      Animation: $t,
      getCache: Dt,
      _removeLinkedListItem: Te,
      reverting: function () {
        return ut
      },
      context: function (t) {
        return t && N && (N.data.push(t), (t._ctx = N)), N
      },
      suppressOverwrites: function (t) {
        return (Me = t)
      }
    }
  }
H('to,from,fromTo,delayedCall,set,killTweensOf', function (u) {
  return (Oe[u] = V[u])
}),
  tt.add($.updateRoot),
  (Gt = Oe.to(
    {},
    {
      duration: 0
    }
  ))
var Tn = function (t, e) {
    for (var i = t._pt; i && i.p !== e && i.op !== e && i.fp !== e; )
      i = i._next
    return i
  },
  wn = function (t, e) {
    var i = t._targets,
      r,
      n,
      s
    for (r in e)
      for (n = i.length; n--; )
        (s = t._ptLookup[n][r]),
          s &&
            (s = s.d) &&
            (s._pt && (s = Tn(s, r)),
            s && s.modifier && s.modifier(e[r], t, i[n], r))
  },
  ni = function (t, e) {
    return {
      name: t,
      rawVars: 1,
      init: function (r, n, s) {
        s._onInit = function (a) {
          var o, f
          if (
            (X(n) &&
              ((o = {}),
              H(n, function (h) {
                return (o[h] = 1)
              }),
              (n = o)),
            e)
          ) {
            o = {}
            for (f in n) o[f] = e(n[f])
            n = o
          }
          wn(a, n)
        }
      }
    }
  },
  et =
    Oe.registerPlugin(
      {
        name: 'attr',
        init: function (t, e, i, r, n) {
          var s, a, o
          this.tween = i
          for (s in e)
            (o = t.getAttribute(s) || ''),
              (a = this.add(
                t,
                'setAttribute',
                (o || 0) + '',
                e[s],
                r,
                n,
                0,
                0,
                s
              )),
              (a.op = s),
              (a.b = o),
              this._props.push(s)
        },
        render: function (t, e) {
          for (var i = e._pt; i; )
            ut ? i.set(i.t, i.p, i.b, i) : i.r(t, i.d), (i = i._next)
        }
      },
      {
        name: 'endArray',
        init: function (t, e) {
          for (var i = e.length; i--; )
            this.add(t, i, t[i] || 0, e[i], 0, 0, 0, 0, 0, 1)
        }
      },
      ni('roundProps', We),
      ni('modifiers'),
      ni('snap', qi)
    ) || Oe
;(V.version = $.version = et.version = '3.11.0'), (Si = 1), vi() && Wt()
var bn = k.Power0,
  Pn = k.Power1,
  Sn = k.Power2,
  On = k.Power3,
  kn = k.Power4,
  Cn = k.Linear,
  Mn = k.Quad,
  Dn = k.Cubic,
  An = k.Quart,
  Rn = k.Quint,
  En = k.Strong,
  Fn = k.Elastic,
  zn = k.Back,
  Ln = k.SteppedEase,
  In = k.Bounce,
  Bn = k.Sine,
  Nn = k.Expo,
  Vn = k.Circ
/*!
 * CSSPlugin 3.11.0
 * https://greensock.com
 *
 * Copyright 2008-2022, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */
var lr,
  St,
  Ht,
  si,
  zt,
  cr,
  ai,
  Un = function () {
    return typeof window != 'undefined'
  },
  yt = {},
  Lt = 180 / Math.PI,
  Kt = Math.PI / 180,
  Zt = Math.atan2,
  dr = 1e8,
  oi = /([A-Z])/g,
  Yn = /(left|right|width|margin|padding|x)/i,
  Xn = /[\s,\(]\S/,
  xt = {
    autoAlpha: 'opacity,visibility',
    scale: 'scaleX,scaleY',
    alpha: 'opacity'
  },
  ui = function (t, e) {
    return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e)
  },
  qn = function (t, e) {
    return e.set(
      e.t,
      e.p,
      t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u,
      e
    )
  },
  Gn = function (t, e) {
    return e.set(
      e.t,
      e.p,
      t ? Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u : e.b,
      e
    )
  },
  Wn = function (t, e) {
    var i = e.s + e.c * t
    e.set(e.t, e.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + e.u, e)
  },
  pr = function (t, e) {
    return e.set(e.t, e.p, t ? e.e : e.b, e)
  },
  mr = function (t, e) {
    return e.set(e.t, e.p, t !== 1 ? e.b : e.e, e)
  },
  $n = function (t, e, i) {
    return (t.style[e] = i)
  },
  Qn = function (t, e, i) {
    return t.style.setProperty(e, i)
  },
  Hn = function (t, e, i) {
    return (t._gsap[e] = i)
  },
  Kn = function (t, e, i) {
    return (t._gsap.scaleX = t._gsap.scaleY = i)
  },
  Zn = function (t, e, i, r, n) {
    var s = t._gsap
    ;(s.scaleX = s.scaleY = i), s.renderTransform(n, s)
  },
  jn = function (t, e, i, r, n) {
    var s = t._gsap
    ;(s[e] = i), s.renderTransform(n, s)
  },
  L = 'transform',
  _t = L + 'Origin',
  Jn = function (t) {
    var e = this,
      i = this.target,
      r = i.style
    if (t in yt) {
      if (
        ((this.tfm = this.tfm || {}),
        t !== 'transform' &&
          ((t = xt[t] || t),
          ~t.indexOf(',')
            ? t.split(',').forEach(function (n) {
                return (e.tfm[n] = vt(i, n))
              })
            : (this.tfm[t] = i._gsap.x ? i._gsap[t] : vt(i, t))),
        i._gsap.svg && (this.svg = i.getAttribute(t) || ''),
        this.props.indexOf(L) >= 0)
      )
        return
      t = L
    }
    r && this.props.push(t, r[t])
  },
  gr = function (t) {
    t.translate &&
      (t.removeProperty('translate'),
      t.removeProperty('scale'),
      t.removeProperty('rotate'))
  },
  ts = function () {
    var t = this.props,
      e = this.target,
      i = e.style,
      r = e._gsap,
      n,
      s
    for (n = 0; n < t.length; n += 2)
      t[n + 1]
        ? (i[t[n]] = t[n + 1])
        : i.removeProperty(t[n].replace(oi, '-$1').toLowerCase())
    if (this.tfm) {
      r.svg && e.setAttribute('transform', this.svg || '')
      for (s in this.tfm) r[s] = this.tfm[s]
      ;(n = ai()), n && !n.isStart && !i[L] && (gr(i), (r.uncache = 1))
    }
  },
  yr = function (t, e) {
    var i = {
      target: t,
      props: [],
      revert: ts,
      save: Jn
    }
    return (
      e &&
        e.split(',').forEach(function (r) {
          return i.save(r)
        }),
      i
    )
  },
  xr,
  fi = function (t, e) {
    var i = St.createElementNS
      ? St.createElementNS(
          (e || 'http://www.w3.org/1999/xhtml').replace(/^https/, 'http'),
          t
        )
      : St.createElement(t)
    return i.style ? i : St.createElement(t)
  },
  lt = function u (t, e, i) {
    var r = getComputedStyle(t)
    return (
      r[e] ||
      r.getPropertyValue(e.replace(oi, '-$1').toLowerCase()) ||
      r.getPropertyValue(e) ||
      (!i && u(t, jt(e) || e, 1)) ||
      ''
    )
  },
  vr = 'O,Moz,ms,Ms,Webkit'.split(','),
  jt = function (t, e, i) {
    var r = e || zt,
      n = r.style,
      s = 5
    if (t in n && !i) return t
    for (
      t = t.charAt(0).toUpperCase() + t.substr(1);
      s-- && !(vr[s] + t in n);

    );
    return s < 0 ? null : (s === 3 ? 'ms' : s >= 0 ? vr[s] : '') + t
  },
  hi = function () {
    Un() &&
      window.document &&
      ((lr = window),
      (St = lr.document),
      (Ht = St.documentElement),
      (zt = fi('div') || {
        style: {}
      }),
      fi('div'),
      (L = jt(L)),
      (_t = L + 'Origin'),
      (zt.style.cssText =
        'border-width:0;line-height:0;position:absolute;padding:0'),
      (xr = !!jt('perspective')),
      (ai = et.core.reverting),
      (si = 1))
  },
  _i = function u (t) {
    var e = fi(
        'svg',
        (this.ownerSVGElement && this.ownerSVGElement.getAttribute('xmlns')) ||
          'http://www.w3.org/2000/svg'
      ),
      i = this.parentNode,
      r = this.nextSibling,
      n = this.style.cssText,
      s
    if (
      (Ht.appendChild(e),
      e.appendChild(this),
      (this.style.display = 'block'),
      t)
    )
      try {
        ;(s = this.getBBox()),
          (this._gsapBBox = this.getBBox),
          (this.getBBox = u)
      } catch (a) {}
    else this._gsapBBox && (s = this._gsapBBox())
    return (
      i && (r ? i.insertBefore(this, r) : i.appendChild(this)),
      Ht.removeChild(e),
      (this.style.cssText = n),
      s
    )
  },
  Tr = function (t, e) {
    for (var i = e.length; i--; )
      if (t.hasAttribute(e[i])) return t.getAttribute(e[i])
  },
  wr = function (t) {
    var e
    try {
      e = t.getBBox()
    } catch (i) {
      e = _i.call(t, !0)
    }
    return (
      (e && (e.width || e.height)) || t.getBBox === _i || (e = _i.call(t, !0)),
      e && !e.width && !e.x && !e.y
        ? {
            x: +Tr(t, ['x', 'cx', 'x1']) || 0,
            y: +Tr(t, ['y', 'cy', 'y1']) || 0,
            width: 0,
            height: 0
          }
        : e
    )
  },
  br = function (t) {
    return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && wr(t))
  },
  _e = function (t, e) {
    if (e) {
      var i = t.style
      e in yt && e !== _t && (e = L),
        i.removeProperty
          ? ((e.substr(0, 2) === 'ms' || e.substr(0, 6) === 'webkit') &&
              (e = '-' + e),
            i.removeProperty(e.replace(oi, '-$1').toLowerCase()))
          : i.removeAttribute(e)
    }
  },
  Ot = function (t, e, i, r, n, s) {
    var a = new K(t._pt, e, i, 0, 1, s ? mr : pr)
    return (t._pt = a), (a.b = r), (a.e = n), t._props.push(i), a
  },
  Pr = {
    deg: 1,
    rad: 1,
    turn: 1
  },
  es = {
    grid: 1,
    flex: 1
  },
  kt = function u (t, e, i, r) {
    var n = parseFloat(i) || 0,
      s = (i + '').trim().substr((n + '').length) || 'px',
      a = zt.style,
      o = Yn.test(e),
      f = t.tagName.toLowerCase() === 'svg',
      h = (f ? 'client' : 'offset') + (o ? 'Width' : 'Height'),
      c = 100,
      l = r === 'px',
      d = r === '%',
      p,
      _,
      m,
      g
    return r === s || !n || Pr[r] || Pr[s]
      ? n
      : (s !== 'px' && !l && (n = u(t, e, i, 'px')),
        (g = t.getCTM && br(t)),
        (d || s === '%') && (yt[e] || ~e.indexOf('adius'))
          ? ((p = g ? t.getBBox()[o ? 'width' : 'height'] : t[h]),
            I(d ? (n / p) * c : (n / 100) * p))
          : ((a[o ? 'width' : 'height'] = c + (l ? s : r)),
            (_ =
              ~e.indexOf('adius') || (r === 'em' && t.appendChild && !f)
                ? t
                : t.parentNode),
            g && (_ = (t.ownerSVGElement || {}).parentNode),
            (!_ || _ === St || !_.appendChild) && (_ = St.body),
            (m = _._gsap),
            m && d && m.width && o && m.time === tt.time && !m.uncache
              ? I((n / m.width) * c)
              : ((d || s === '%') &&
                  !es[lt(_, 'display')] &&
                  (a.position = lt(t, 'position')),
                _ === t && (a.position = 'static'),
                _.appendChild(zt),
                (p = zt[h]),
                _.removeChild(zt),
                (a.position = 'absolute'),
                o && d && ((m = Dt(_)), (m.time = tt.time), (m.width = _[h])),
                I(l ? (p * n) / c : p && n ? (c / p) * n : 0))))
  },
  vt = function (t, e, i, r) {
    var n
    return (
      si || hi(),
      e in xt &&
        e !== 'transform' &&
        ((e = xt[e]), ~e.indexOf(',') && (e = e.split(',')[0])),
      yt[e] && e !== 'transform'
        ? ((n = ce(t, r)),
          (n =
            e !== 'transformOrigin'
              ? n[e]
              : n.svg
              ? n.origin
              : Ce(lt(t, _t)) + ' ' + n.zOrigin + 'px'))
        : ((n = t.style[e]),
          (!n || n === 'auto' || r || ~(n + '').indexOf('calc(')) &&
            (n =
              (ke[e] && ke[e](t, e, i)) ||
              lt(t, e) ||
              Di(t, e) ||
              (e === 'opacity' ? 1 : 0))),
      i && !~(n + '').trim().indexOf(' ') ? kt(t, e, n, i) + i : n
    )
  },
  is = function (t, e, i, r) {
    if (!i || i === 'none') {
      var n = jt(e, t, 1),
        s = n && lt(t, n, 1)
      s && s !== i
        ? ((e = n), (i = s))
        : e === 'borderColor' && (i = lt(t, 'borderTopColor'))
    }
    var a = new K(this._pt, t.style, e, 0, 1, ur),
      o = 0,
      f = 0,
      h,
      c,
      l,
      d,
      p,
      _,
      m,
      g,
      x,
      v,
      T,
      y
    if (
      ((a.b = i),
      (a.e = r),
      (i += ''),
      (r += ''),
      r === 'auto' && ((t.style[e] = r), (r = lt(t, e) || r), (t.style[e] = i)),
      (h = [i, r]),
      ji(h),
      (i = h[0]),
      (r = h[1]),
      (l = i.match(Ut) || []),
      (y = r.match(Ut) || []),
      y.length)
    ) {
      for (; (c = Ut.exec(r)); )
        (m = c[0]),
          (x = r.substring(o, c.index)),
          p
            ? (p = (p + 1) % 5)
            : (x.substr(-5) === 'rgba(' || x.substr(-5) === 'hsla(') && (p = 1),
          m !== (_ = l[f++] || '') &&
            ((d = parseFloat(_) || 0),
            (T = _.substr((d + '').length)),
            m.charAt(1) === '=' && (m = Yt(d, m) + T),
            (g = parseFloat(m)),
            (v = m.substr((g + '').length)),
            (o = Ut.lastIndex - v.length),
            v ||
              ((v = v || Z.units[e] || T),
              o === r.length && ((r += v), (a.e += v))),
            T !== v && (d = kt(t, e, _, v) || 0),
            (a._pt = {
              _next: a._pt,
              p: x || f === 1 ? x : ',',
              s: d,
              c: g - d,
              m: (p && p < 4) || e === 'zIndex' ? Math.round : 0
            }))
      a.c = o < r.length ? r.substring(o, r.length) : ''
    } else a.r = e === 'display' && r === 'none' ? mr : pr
    return bi.test(r) && (a.e = 0), (this._pt = a), a
  },
  Sr = {
    top: '0%',
    bottom: '100%',
    left: '0%',
    right: '100%',
    center: '50%'
  },
  rs = function (t) {
    var e = t.split(' '),
      i = e[0],
      r = e[1] || '50%'
    return (
      (i === 'top' || i === 'bottom' || r === 'left' || r === 'right') &&
        ((t = i), (i = r), (r = t)),
      (e[0] = Sr[i] || i),
      (e[1] = Sr[r] || r),
      e.join(' ')
    )
  },
  ns = function (t, e) {
    if (e.tween && e.tween._time === e.tween._dur) {
      var i = e.t,
        r = i.style,
        n = e.u,
        s = i._gsap,
        a,
        o,
        f
      if (n === 'all' || n === !0) (r.cssText = ''), (o = 1)
      else
        for (n = n.split(','), f = n.length; --f > -1; )
          (a = n[f]),
            yt[a] && ((o = 1), (a = a === 'transformOrigin' ? _t : L)),
            _e(i, a)
      o &&
        (_e(i, L),
        s &&
          (s.svg && i.removeAttribute('transform'),
          ce(i, 1),
          (s.uncache = 1),
          gr(r)))
    }
  },
  ke = {
    clearProps: function (t, e, i, r, n) {
      if (n.data !== 'isFromStart') {
        var s = (t._pt = new K(t._pt, e, i, 0, 0, ns))
        return (s.u = r), (s.pr = -10), (s.tween = n), t._props.push(i), 1
      }
    }
  },
  le = [1, 0, 0, 1, 0, 0],
  Or = {},
  kr = function (t) {
    return t === 'matrix(1, 0, 0, 1, 0, 0)' || t === 'none' || !t
  },
  Cr = function (t) {
    var e = lt(t, L)
    return kr(e)
      ? le
      : e
          .substr(7)
          .match(wi)
          .map(I)
  },
  li = function (t, e) {
    var i = t._gsap || Dt(t),
      r = t.style,
      n = Cr(t),
      s,
      a,
      o,
      f
    return i.svg && t.getAttribute('transform')
      ? ((o = t.transform.baseVal.consolidate().matrix),
        (n = [o.a, o.b, o.c, o.d, o.e, o.f]),
        n.join(',') === '1,0,0,1,0,0' ? le : n)
      : (n === le &&
          !t.offsetParent &&
          t !== Ht &&
          !i.svg &&
          ((o = r.display),
          (r.display = 'block'),
          (s = t.parentNode),
          (!s || !t.offsetParent) &&
            ((f = 1), (a = t.nextElementSibling), Ht.appendChild(t)),
          (n = Cr(t)),
          o ? (r.display = o) : _e(t, 'display'),
          f &&
            (a
              ? s.insertBefore(t, a)
              : s
              ? s.appendChild(t)
              : Ht.removeChild(t))),
        e && n.length > 6 ? [n[0], n[1], n[4], n[5], n[12], n[13]] : n)
  },
  ci = function (t, e, i, r, n, s) {
    var a = t._gsap,
      o = n || li(t, !0),
      f = a.xOrigin || 0,
      h = a.yOrigin || 0,
      c = a.xOffset || 0,
      l = a.yOffset || 0,
      d = o[0],
      p = o[1],
      _ = o[2],
      m = o[3],
      g = o[4],
      x = o[5],
      v = e.split(' '),
      T = parseFloat(v[0]) || 0,
      y = parseFloat(v[1]) || 0,
      S,
      P,
      b,
      w
    i
      ? o !== le &&
        (P = d * m - p * _) &&
        ((b = T * (m / P) + y * (-_ / P) + (_ * x - m * g) / P),
        (w = T * (-p / P) + y * (d / P) - (d * x - p * g) / P),
        (T = b),
        (y = w))
      : ((S = wr(t)),
        (T = S.x + (~v[0].indexOf('%') ? (T / 100) * S.width : T)),
        (y = S.y + (~(v[1] || v[0]).indexOf('%') ? (y / 100) * S.height : y))),
      r || (r !== !1 && a.smooth)
        ? ((g = T - f),
          (x = y - h),
          (a.xOffset = c + (g * d + x * _) - g),
          (a.yOffset = l + (g * p + x * m) - x))
        : (a.xOffset = a.yOffset = 0),
      (a.xOrigin = T),
      (a.yOrigin = y),
      (a.smooth = !!r),
      (a.origin = e),
      (a.originIsAbsolute = !!i),
      (t.style[_t] = '0px 0px'),
      s &&
        (Ot(s, a, 'xOrigin', f, T),
        Ot(s, a, 'yOrigin', h, y),
        Ot(s, a, 'xOffset', c, a.xOffset),
        Ot(s, a, 'yOffset', l, a.yOffset)),
      t.setAttribute('data-svg-origin', T + ' ' + y)
  },
  ce = function (t, e) {
    var i = t._gsap || new ir(t)
    if ('x' in i && !e && !i.uncache) return i
    var r = t.style,
      n = i.scaleX < 0,
      s = 'px',
      a = 'deg',
      o = getComputedStyle(t),
      f = lt(t, _t) || '0',
      h,
      c,
      l,
      d,
      p,
      _,
      m,
      g,
      x,
      v,
      T,
      y,
      S,
      P,
      b,
      w,
      O,
      D,
      E,
      A,
      F,
      Y,
      U,
      B,
      ct,
      Nt,
      Jt,
      te,
      Ct,
      gi,
      dt,
      Mt
    return (
      (h = c = l = _ = m = g = x = v = T = 0),
      (d = p = 1),
      (i.svg = !!(t.getCTM && br(t))),
      o.translate &&
        ((o.translate !== 'none' ||
          o.scale !== 'none' ||
          o.rotate !== 'none') &&
          (r[L] =
            (o.translate !== 'none'
              ? 'translate3d(' +
                (o.translate + ' 0 0')
                  .split(' ')
                  .slice(0, 3)
                  .join(', ') +
                ') '
              : '') +
            (o.rotate !== 'none' ? 'rotate(' + o.rotate + ') ' : '') +
            (o.scale !== 'none'
              ? 'scale(' + o.scale.split(' ').join(',') + ') '
              : '') +
            o[L]),
        (r.scale = r.rotate = r.translate = 'none')),
      (P = li(t, i.svg)),
      i.svg &&
        ((B =
          (!i.uncache || f === '0px 0px') &&
          !e &&
          t.getAttribute('data-svg-origin')),
        ci(t, B || f, !!B || i.originIsAbsolute, i.smooth !== !1, P)),
      (y = i.xOrigin || 0),
      (S = i.yOrigin || 0),
      P !== le &&
        ((D = P[0]),
        (E = P[1]),
        (A = P[2]),
        (F = P[3]),
        (h = Y = P[4]),
        (c = U = P[5]),
        P.length === 6
          ? ((d = Math.sqrt(D * D + E * E)),
            (p = Math.sqrt(F * F + A * A)),
            (_ = D || E ? Zt(E, D) * Lt : 0),
            (x = A || F ? Zt(A, F) * Lt + _ : 0),
            x && (p *= Math.abs(Math.cos(x * Kt))),
            i.svg && ((h -= y - (y * D + S * A)), (c -= S - (y * E + S * F))))
          : ((Mt = P[6]),
            (gi = P[7]),
            (Jt = P[8]),
            (te = P[9]),
            (Ct = P[10]),
            (dt = P[11]),
            (h = P[12]),
            (c = P[13]),
            (l = P[14]),
            (b = Zt(Mt, Ct)),
            (m = b * Lt),
            b &&
              ((w = Math.cos(-b)),
              (O = Math.sin(-b)),
              (B = Y * w + Jt * O),
              (ct = U * w + te * O),
              (Nt = Mt * w + Ct * O),
              (Jt = Y * -O + Jt * w),
              (te = U * -O + te * w),
              (Ct = Mt * -O + Ct * w),
              (dt = gi * -O + dt * w),
              (Y = B),
              (U = ct),
              (Mt = Nt)),
            (b = Zt(-A, Ct)),
            (g = b * Lt),
            b &&
              ((w = Math.cos(-b)),
              (O = Math.sin(-b)),
              (B = D * w - Jt * O),
              (ct = E * w - te * O),
              (Nt = A * w - Ct * O),
              (dt = F * O + dt * w),
              (D = B),
              (E = ct),
              (A = Nt)),
            (b = Zt(E, D)),
            (_ = b * Lt),
            b &&
              ((w = Math.cos(b)),
              (O = Math.sin(b)),
              (B = D * w + E * O),
              (ct = Y * w + U * O),
              (E = E * w - D * O),
              (U = U * w - Y * O),
              (D = B),
              (Y = ct)),
            m &&
              Math.abs(m) + Math.abs(_) > 359.9 &&
              ((m = _ = 0), (g = 180 - g)),
            (d = I(Math.sqrt(D * D + E * E + A * A))),
            (p = I(Math.sqrt(U * U + Mt * Mt))),
            (b = Zt(Y, U)),
            (x = Math.abs(b) > 2e-4 ? b * Lt : 0),
            (T = dt ? 1 / (dt < 0 ? -dt : dt) : 0)),
        i.svg &&
          ((B = t.getAttribute('transform')),
          (i.forceCSS = t.setAttribute('transform', '') || !kr(lt(t, L))),
          B && t.setAttribute('transform', B))),
      Math.abs(x) > 90 &&
        Math.abs(x) < 270 &&
        (n
          ? ((d *= -1), (x += _ <= 0 ? 180 : -180), (_ += _ <= 0 ? 180 : -180))
          : ((p *= -1), (x += x <= 0 ? 180 : -180))),
      (e = e || i.uncache),
      (i.x =
        h -
        ((i.xPercent =
          h &&
          ((!e && i.xPercent) ||
            (Math.round(t.offsetWidth / 2) === Math.round(-h) ? -50 : 0)))
          ? (t.offsetWidth * i.xPercent) / 100
          : 0) +
        s),
      (i.y =
        c -
        ((i.yPercent =
          c &&
          ((!e && i.yPercent) ||
            (Math.round(t.offsetHeight / 2) === Math.round(-c) ? -50 : 0)))
          ? (t.offsetHeight * i.yPercent) / 100
          : 0) +
        s),
      (i.z = l + s),
      (i.scaleX = I(d)),
      (i.scaleY = I(p)),
      (i.rotation = I(_) + a),
      (i.rotationX = I(m) + a),
      (i.rotationY = I(g) + a),
      (i.skewX = x + a),
      (i.skewY = v + a),
      (i.transformPerspective = T + s),
      (i.zOrigin = parseFloat(f.split(' ')[2]) || 0) && (r[_t] = Ce(f)),
      (i.xOffset = i.yOffset = 0),
      (i.force3D = Z.force3D),
      (i.renderTransform = i.svg ? as : xr ? Mr : ss),
      (i.uncache = 0),
      i
    )
  },
  Ce = function (t) {
    return (t = t.split(' '))[0] + ' ' + t[1]
  },
  di = function (t, e, i) {
    var r = W(e)
    return I(parseFloat(e) + parseFloat(kt(t, 'x', i + 'px', r))) + r
  },
  ss = function (t, e) {
    ;(e.z = '0px'),
      (e.rotationY = e.rotationX = '0deg'),
      (e.force3D = 0),
      Mr(t, e)
  },
  It = '0deg',
  de = '0px',
  Bt = ') ',
  Mr = function (t, e) {
    var i = e || this,
      r = i.xPercent,
      n = i.yPercent,
      s = i.x,
      a = i.y,
      o = i.z,
      f = i.rotation,
      h = i.rotationY,
      c = i.rotationX,
      l = i.skewX,
      d = i.skewY,
      p = i.scaleX,
      _ = i.scaleY,
      m = i.transformPerspective,
      g = i.force3D,
      x = i.target,
      v = i.zOrigin,
      T = '',
      y = (g === 'auto' && t && t !== 1) || g === !0
    if (v && (c !== It || h !== It)) {
      var S = parseFloat(h) * Kt,
        P = Math.sin(S),
        b = Math.cos(S),
        w
      ;(S = parseFloat(c) * Kt),
        (w = Math.cos(S)),
        (s = di(x, s, P * w * -v)),
        (a = di(x, a, -Math.sin(S) * -v)),
        (o = di(x, o, b * w * -v + v))
    }
    m !== de && (T += 'perspective(' + m + Bt),
      (r || n) && (T += 'translate(' + r + '%, ' + n + '%) '),
      (y || s !== de || a !== de || o !== de) &&
        (T +=
          o !== de || y
            ? 'translate3d(' + s + ', ' + a + ', ' + o + ') '
            : 'translate(' + s + ', ' + a + Bt),
      f !== It && (T += 'rotate(' + f + Bt),
      h !== It && (T += 'rotateY(' + h + Bt),
      c !== It && (T += 'rotateX(' + c + Bt),
      (l !== It || d !== It) && (T += 'skew(' + l + ', ' + d + Bt),
      (p !== 1 || _ !== 1) && (T += 'scale(' + p + ', ' + _ + Bt),
      (x.style[L] = T || 'translate(0, 0)')
  },
  as = function (t, e) {
    var i = e || this,
      r = i.xPercent,
      n = i.yPercent,
      s = i.x,
      a = i.y,
      o = i.rotation,
      f = i.skewX,
      h = i.skewY,
      c = i.scaleX,
      l = i.scaleY,
      d = i.target,
      p = i.xOrigin,
      _ = i.yOrigin,
      m = i.xOffset,
      g = i.yOffset,
      x = i.forceCSS,
      v = parseFloat(s),
      T = parseFloat(a),
      y,
      S,
      P,
      b,
      w
    ;(o = parseFloat(o)),
      (f = parseFloat(f)),
      (h = parseFloat(h)),
      h && ((h = parseFloat(h)), (f += h), (o += h)),
      o || f
        ? ((o *= Kt),
          (f *= Kt),
          (y = Math.cos(o) * c),
          (S = Math.sin(o) * c),
          (P = Math.sin(o - f) * -l),
          (b = Math.cos(o - f) * l),
          f &&
            ((h *= Kt),
            (w = Math.tan(f - h)),
            (w = Math.sqrt(1 + w * w)),
            (P *= w),
            (b *= w),
            h &&
              ((w = Math.tan(h)),
              (w = Math.sqrt(1 + w * w)),
              (y *= w),
              (S *= w))),
          (y = I(y)),
          (S = I(S)),
          (P = I(P)),
          (b = I(b)))
        : ((y = c), (b = l), (S = P = 0)),
      ((v && !~(s + '').indexOf('px')) || (T && !~(a + '').indexOf('px'))) &&
        ((v = kt(d, 'x', s, 'px')), (T = kt(d, 'y', a, 'px'))),
      (p || _ || m || g) &&
        ((v = I(v + p - (p * y + _ * P) + m)),
        (T = I(T + _ - (p * S + _ * b) + g))),
      (r || n) &&
        ((w = d.getBBox()),
        (v = I(v + (r / 100) * w.width)),
        (T = I(T + (n / 100) * w.height))),
      (w =
        'matrix(' + y + ',' + S + ',' + P + ',' + b + ',' + v + ',' + T + ')'),
      d.setAttribute('transform', w),
      x && (d.style[L] = w)
  },
  os = function (t, e, i, r, n) {
    var s = 360,
      a = X(n),
      o = parseFloat(n) * (a && ~n.indexOf('rad') ? Lt : 1),
      f = o - r,
      h = r + f + 'deg',
      c,
      l
    return (
      a &&
        ((c = n.split('_')[1]),
        c === 'short' && ((f %= s), f !== f % (s / 2) && (f += f < 0 ? s : -s)),
        c === 'cw' && f < 0
          ? (f = ((f + s * dr) % s) - ~~(f / s) * s)
          : c === 'ccw' && f > 0 && (f = ((f - s * dr) % s) - ~~(f / s) * s)),
      (t._pt = l = new K(t._pt, e, i, r, f, qn)),
      (l.e = h),
      (l.u = 'deg'),
      t._props.push(i),
      l
    )
  },
  Dr = function (t, e) {
    for (var i in e) t[i] = e[i]
    return t
  },
  us = function (t, e, i) {
    var r = Dr({}, i._gsap),
      n = 'perspective,force3D,transformOrigin,svgOrigin',
      s = i.style,
      a,
      o,
      f,
      h,
      c,
      l,
      d,
      p
    r.svg
      ? ((f = i.getAttribute('transform')),
        i.setAttribute('transform', ''),
        (s[L] = e),
        (a = ce(i, 1)),
        _e(i, L),
        i.setAttribute('transform', f))
      : ((f = getComputedStyle(i)[L]), (s[L] = e), (a = ce(i, 1)), (s[L] = f))
    for (o in yt)
      (f = r[o]),
        (h = a[o]),
        f !== h &&
          n.indexOf(o) < 0 &&
          ((d = W(f)),
          (p = W(h)),
          (c = d !== p ? kt(i, o, f, p) : parseFloat(f)),
          (l = parseFloat(h)),
          (t._pt = new K(t._pt, a, o, c, l - c, ui)),
          (t._pt.u = p || 0),
          t._props.push(o))
    Dr(a, r)
  }
H('padding,margin,Width,Radius', function (u, t) {
  var e = 'Top',
    i = 'Right',
    r = 'Bottom',
    n = 'Left',
    s = (t < 3 ? [e, i, r, n] : [e + n, e + i, r + i, r + n]).map(function (a) {
      return t < 2 ? u + a : 'border' + a + u
    })
  ke[t > 1 ? 'border' + u : u] = function (a, o, f, h, c) {
    var l, d
    if (arguments.length < 4)
      return (
        (l = s.map(function (p) {
          return vt(a, p, f)
        })),
        (d = l.join(' ')),
        d.split(l[0]).length === 5 ? l[0] : d
      )
    ;(l = (h + '').split(' ')),
      (d = {}),
      s.forEach(function (p, _) {
        return (d[p] = l[_] = l[_] || l[((_ - 1) / 2) | 0])
      }),
      a.init(o, d, c)
  }
})
var pi = {
  name: 'css',
  register: hi,
  targetTest: function (t) {
    return t.style && t.nodeType
  },
  init: function (t, e, i, r, n) {
    var s = this._props,
      a = t.style,
      o = i.vars.startAt,
      f,
      h,
      c,
      l,
      d,
      p,
      _,
      m,
      g,
      x,
      v,
      T,
      y,
      S,
      P,
      b
    si || hi(),
      (this.styles = this.styles || yr(t)),
      (b = this.styles.props),
      (this.tween = i)
    for (_ in e) {
      if (_ === 'autoRound') continue
      if (((h = e[_]), J[_] && rr(_, e, i, r, t, n))) continue
      if (
        ((d = typeof h),
        (p = ke[_]),
        d === 'function' && ((h = h.call(i, r, t, n)), (d = typeof h)),
        d === 'string' && ~h.indexOf('random(') && (h = ae(h)),
        p)
      )
        p(this, t, _, h, i) && (P = 1)
      else if (_.substr(0, 2) === '--')
        (f = (getComputedStyle(t).getPropertyValue(_) + '').trim()),
          (h += ''),
          (bt.lastIndex = 0),
          bt.test(f) || ((m = W(f)), (g = W(h))),
          g ? m !== g && (f = kt(t, _, f, g) + g) : m && (h += m),
          this.add(a, 'setProperty', f, h, r, n, 0, 0, _),
          s.push(_),
          b.push(_, a[_])
      else if (d !== 'undefined') {
        if (
          (o && _ in o
            ? ((f = typeof o[_] == 'function' ? o[_].call(i, r, t, n) : o[_]),
              X(f) && ~f.indexOf('random(') && (f = ae(f)),
              W(f + '') || (f += Z.units[_] || W(vt(t, _)) || ''),
              (f + '').charAt(1) === '=' && (f = vt(t, _)))
            : (f = vt(t, _)),
          (l = parseFloat(f)),
          (x = d === 'string' && h.charAt(1) === '=' && h.substr(0, 2)),
          x && (h = h.substr(2)),
          (c = parseFloat(h)),
          _ in xt &&
            (_ === 'autoAlpha' &&
              (l === 1 && vt(t, 'visibility') === 'hidden' && c && (l = 0),
              b.push('visibility', a.visibility),
              Ot(
                this,
                a,
                'visibility',
                l ? 'inherit' : 'hidden',
                c ? 'inherit' : 'hidden',
                !c
              )),
            _ !== 'scale' &&
              _ !== 'transform' &&
              ((_ = xt[_]), ~_.indexOf(',') && (_ = _.split(',')[0]))),
          (v = _ in yt),
          v)
        ) {
          if (
            (this.styles.save(_),
            T ||
              ((y = t._gsap),
              (y.renderTransform && !e.parseTransform) ||
                ce(t, e.parseTransform),
              (S = e.smoothOrigin !== !1 && y.smooth),
              (T = this._pt = new K(
                this._pt,
                a,
                L,
                0,
                1,
                y.renderTransform,
                y,
                0,
                -1
              )),
              (T.dep = 1)),
            _ === 'scale')
          )
            (this._pt = new K(
              this._pt,
              y,
              'scaleY',
              y.scaleY,
              (x ? Yt(y.scaleY, x + c) : c) - y.scaleY || 0,
              ui
            )),
              (this._pt.u = 0),
              s.push('scaleY', _),
              (_ += 'X')
          else if (_ === 'transformOrigin') {
            b.push(_t, a[_t]),
              (h = rs(h)),
              y.svg
                ? ci(t, h, 0, S, 0, this)
                : ((g = parseFloat(h.split(' ')[2]) || 0),
                  g !== y.zOrigin && Ot(this, y, 'zOrigin', y.zOrigin, g),
                  Ot(this, a, _, Ce(f), Ce(h)))
            continue
          } else if (_ === 'svgOrigin') {
            ci(t, h, 1, S, 0, this)
            continue
          } else if (_ in Or) {
            os(this, y, _, l, x ? Yt(l, x + h) : h)
            continue
          } else if (_ === 'smoothOrigin') {
            Ot(this, y, 'smooth', y.smooth, h)
            continue
          } else if (_ === 'force3D') {
            y[_] = h
            continue
          } else if (_ === 'transform') {
            us(this, h, t)
            continue
          }
        } else _ in a || (_ = jt(_) || _)
        if (v || ((c || c === 0) && (l || l === 0) && !Xn.test(h) && _ in a))
          (m = (f + '').substr((l + '').length)),
            c || (c = 0),
            (g = W(h) || (_ in Z.units ? Z.units[_] : m)),
            m !== g && (l = kt(t, _, f, g)),
            (this._pt = new K(
              this._pt,
              v ? y : a,
              _,
              l,
              (x ? Yt(l, x + c) : c) - l,
              !v && (g === 'px' || _ === 'zIndex') && e.autoRound !== !1
                ? Wn
                : ui
            )),
            (this._pt.u = g || 0),
            m !== g && g !== '%' && ((this._pt.b = f), (this._pt.r = Gn))
        else if (_ in a) is.call(this, t, _, f, x ? x + h : h)
        else if (_ in t) this.add(t, _, f || t[_], x ? x + h : h, r, n)
        else {
          Le(_, h)
          continue
        }
        v || b.push(_, a[_]), s.push(_)
      }
    }
    P && fr(this)
  },
  render: function (t, e) {
    if (e.tween._time || !ai())
      for (var i = e._pt; i; ) i.r(t, i.d), (i = i._next)
    else e.styles.revert()
  },
  get: vt,
  aliases: xt,
  getSetter: function (t, e, i) {
    var r = xt[e]
    return (
      r && r.indexOf(',') < 0 && (e = r),
      e in yt && e !== _t && (t._gsap.x || vt(t, 'x'))
        ? i && cr === i
          ? e === 'scale'
            ? Kn
            : Hn
          : (cr = i || {}) && (e === 'scale' ? Zn : jn)
        : t.style && !Ae(t.style[e])
        ? $n
        : ~e.indexOf('-')
        ? Qn
        : ti(t, e)
    )
  },
  core: {
    _removeProperty: _e,
    _getMatrix: li
  }
}
;(et.utils.checkPrefix = jt),
  (et.core.getStyleSaver = yr),
  (function (u, t, e, i) {
    var r = H(u + ',' + t + ',' + e, function (n) {
      yt[n] = 1
    })
    H(t, function (n) {
      ;(Z.units[n] = 'deg'), (Or[n] = 1)
    }),
      (xt[r[13]] = u + ',' + t),
      H(i, function (n) {
        var s = n.split(':')
        xt[s[1]] = r[s[0]]
      })
  })(
    'x,y,z,scale,scaleX,scaleY,xPercent,yPercent',
    'rotation,rotationX,rotationY,skewX,skewY',
    'transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective',
    '0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY'
  ),
  H(
    'x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective',
    function (u) {
      Z.units[u] = 'px'
    }
  ),
  et.registerPlugin(pi)
var mi = et.registerPlugin(pi) || et,
  fs = mi.core.Tween
var u = 'undefined' != typeof globalThis ? globalThis : window
u.gsap = mi
export default mi
export {
  zn as Back,
  In as Bounce,
  pi as CSSPlugin,
  Vn as Circ,
  Dn as Cubic,
  Fn as Elastic,
  Nn as Expo,
  Cn as Linear,
  bn as Power0,
  Pn as Power1,
  Sn as Power2,
  On as Power3,
  kn as Power4,
  Mn as Quad,
  An as Quart,
  Rn as Quint,
  Bn as Sine,
  Ln as SteppedEase,
  En as Strong,
  $ as TimelineLite,
  $ as TimelineMax,
  V as TweenLite,
  fs as TweenMax,
  mi as gsap
}
